export const No_Findings_Data = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Security_Q1_Check_Details = [
  {
    CheckId: "iam_user_access_key_check",
    Description: "Unused IAM credentials should be removed",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_hub_enable_check",
    Description: "Security Hub is enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_password_lowercase_check",
    Description:
      "Ensure IAM password policy require at least one lowercase letter",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cognito_identity_pool_password_policy",
    Description:
      "Ensure Cognito Identity Pool Password policy comply with AWS CIS Foundations Benchmark",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_password_symbol_check",
    Description: "Ensure IAM password policy require at least one symbol",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "amazon_macie_in_use_check",
    Description: "Amazon Macie is in use",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "no_root_account_access_key_check",
    Description: "Ensure no root account access key exists",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_hub_cis_enable_check",
    Description: "Enable CIS AWS Foundations Benchmark in Security Hub",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cognito_temporary_password_age_check",
    Description: "Cognito Temporary Password Age",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_role_policies_check",
    Description:
      "Ensure AWS IAM policies allow only the required privileges for each role",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_user_inline_policy_check",
    Description: "Use IAM managed policies",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_user_first_access_key_check",
    Description:
      "Ensure credentials (with first activated accessKey) unused for 90 days or greater are disabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unused_function_check",
    Description: "Lambda functions should be deleted after 30 days of no use",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "securityhub_foundational_security_enable_check",
    Description:
      "Enable AWS foundational Security Best Practices compliance standard is enabled in Security Hub",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "secret_age_check",
    Description: "Secrets over 90 days old should be rotated",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_assume_role_check",
    Description:
      "Ensure AWS IAM policies do not grant assume role permission across all services.",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_password_policy_cis_check",
    Description:
      "Password policies for IAM users should have strong configurations",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_support_role_check",
    Description:
      "Ensure a support role has been created to manage incidents with AWS Support",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_password_length_check",
    Description:
      "Ensure IAM password policy requires minimum length of 14 or greater",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_multiple_active_accesskey_check",
    Description:
      "Ensure there is only one active access key available for any single IAM user",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_password_number_check",
    Description: "Ensure IAM Password Policy requires at least one number",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_user_second_access_key_check",
    Description:
      "Ensure credentials (with second activated accessKey) unused for 90 days or greater are disabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_password_age_check",
    Description:
      "Ensure IAM password policy is set to expire passwords within 90 days or less",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_password_uppercase_check",
    Description:
      "Ensure IAM password policy requires at least one uppercase letter",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kms_cmk_keystate_check",
    Description: "Check for customer managed AWS KMS keys that are disabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Security_Q1_unused_function_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unused_function_check",
      CreatedAt: "2023-04-25 12:24:21",
      FindingId: "274466ce-66ba-4d72-ab7d-cbf9b469954c",
      Metadata: {
        TaskRefId: "cc7e6024-aa8e-4c1c-aeb0-b69616e675d5",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Lambda functions should be deleted after 30 days of no use",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_function_check",
      CreatedAt: "2023-04-25 12:24:21",
      FindingId: "507a89f5-8aca-4a7b-92fc-fcd176834eaa",
      Metadata: {
        TaskRefId: "cc7e6024-aa8e-4c1c-aeb0-b69616e675d5",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Lambda functions should be deleted after 30 days of no use",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_function_check",
      CreatedAt: "2023-04-25 12:24:21",
      FindingId: "c087f3e5-7b2a-4206-8b52-b30af094d392",
      Metadata: {
        TaskRefId: "cc7e6024-aa8e-4c1c-aeb0-b69616e675d5",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Lambda functions should be deleted after 30 days of no use",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_function_check",
      CreatedAt: "2023-04-25 12:24:21",
      FindingId: "c8aa551e-a2f0-442d-a8e9-05de893da11b",
      Metadata: {
        TaskRefId: "cc7e6024-aa8e-4c1c-aeb0-b69616e675d5",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Lambda functions should be deleted after 30 days of no use",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_function_check",
      CreatedAt: "2023-04-25 12:24:21",
      FindingId: "fdbd5432-8e1f-4990-85db-03d0227e4204",
      Metadata: {
        TaskRefId: "cc7e6024-aa8e-4c1c-aeb0-b69616e675d5",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Lambda functions should be deleted after 30 days of no use",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_function_check",
      CreatedAt: "2023-04-25 12:24:21",
      FindingId: "ff4f56fa-6cc8-4145-9f4e-3086ee38a701",
      Metadata: {
        TaskRefId: "cc7e6024-aa8e-4c1c-aeb0-b69616e675d5",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Lambda functions should be deleted after 30 days of no use",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q1_iam_password_uppercase_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_uppercase_check",
      CreatedAt: "2023-04-25 12:23:38",
      FindingId: "24074123-2644-430b-bf55-fb691b7307d1",
      Metadata: {
        TaskRefId: "2f9b3bb8-6c2f-5d25-963e-9742a85d5eed",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check identifies whether the account password policy for IAM users uses atleast one uppercase letter.",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_secret_age_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_security_hub_enable_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_hub_enable_check",
      CreatedAt: "2023-04-25 12:25:11",
      FindingId: "73e05f2c-703d-4314-b532-0663df34b0b2",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Ensure Security Hub is enabled, AWS Security Hub provides you with a comprehensive view of your security state in AWS and helps you check your environment against security industry standards and best practices.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "SecurityHubHighCriticalFindings",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_user_inline_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_amazon_macie_in_use_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "amazon_macie_in_use_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "cdd77705-16c5-4fb9-9079-37c01187312b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Ensure Amazon Macie is enabled in this region, Ensure that Amazon Macie service is currently in use in order to classify and protect sensitive information such as credit cards, financial records or Personally Identifiable Information (PII), available in your AWS account. AWS Macie is a data security service that utilizes machine learning to automatically discover, classify and protect critical data within AWS cloud",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "Macie",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_password_lowercase_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_lowercase_check",
      CreatedAt: "2023-04-25 12:23:37",
      FindingId: "96a97750-e617-4d7b-9810-1c0882e34b4a",
      Metadata: {
        TaskRefId: "36d53f94-e9d5-5991-869e-21679d1bc0ba",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check identifies whether the account password policy for IAM users uses atleast one lowercase letter.",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_password_policy_cis_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_policy_cis_check",
      CreatedAt: "2023-04-25 12:23:38",
      FindingId: "257c4b41-1e43-4001-a5df-884d255bd4f8",
      Metadata: {
        TaskRefId: "8c1789f6-24e8-4fae-8e5e-5dcd56223d9a",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check identifies whether the account password policy for IAM users uses the recommended configurations.",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_password_age_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_age_check",
      CreatedAt: "2023-04-25 12:23:39",
      FindingId: "d6868446-125f-41d0-981a-a9511d2aac11",
      Metadata: {
        TaskRefId: "82b077d2-6ee5-58ed-b2cd-bb539a211505",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check verifies whether IAM password expiration is set to 90 days or less",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_kms_cmk_keystate_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "kms_cmk_keystate_check",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "bb913184-5b18-4255-b1d0-864dcc6d6423",
      Metadata: {
        TaskRefId: "bff3c618-86f3-4d27-ba33-efb8c2ca8bed",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore.  The KMS keys that you create are customer managed keys. This check will find if any of  those keys are disabled so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "fbbb8caa-260c-43f1-b460-94eef2dd8a28",
      ResourceType: "KMSKey",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "kms_cmk_keystate_check",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "4dac000c-7a00-4bda-a941-eabc354085c1",
      Metadata: {
        TaskRefId: "bff3c618-86f3-4d27-ba33-efb8c2ca8bed",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore.  The KMS keys that you create are customer managed keys. This check will find if any of  those keys are disabled so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "f6207312-7015-480d-a6f9-05ebc9a46550",
      ResourceType: "KMSKey",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "kms_cmk_keystate_check",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "5e1ee9e5-5c33-41f2-b49a-fc0167bb8351",
      Metadata: {
        TaskRefId: "bff3c618-86f3-4d27-ba33-efb8c2ca8bed",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore.  The KMS keys that you create are customer managed keys. This check will find if any of  those keys are disabled so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "9dd27eae-e106-4e2d-9acb-ca4d36e7ada7",
      ResourceType: "KMSKey",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "kms_cmk_keystate_check",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "8977c50d-c040-496b-9efc-58f47268e67e",
      Metadata: {
        TaskRefId: "bff3c618-86f3-4d27-ba33-efb8c2ca8bed",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore.  The KMS keys that you create are customer managed keys. This check will find if any of  those keys are disabled so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "66d0e6fe-1ae2-4919-85b8-6966f7e2c1c7",
      ResourceType: "KMSKey",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q1_iam_password_length_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_length_check",
      CreatedAt: "2023-04-25 12:23:37",
      FindingId: "5c2fdcd2-eab9-4ef1-a6a6-4b00b0ac0024",
      Metadata: {
        TaskRefId: "8a193361-39a5-5ffa-90fe-3cffdadadcfa",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check identifies whether the account password policy for IAM users uses atleast 14 characters or more.",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_support_role_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_support_role_check",
      CreatedAt: "2023-04-25 12:24:38",
      FindingId: "b0d1a455-2798-4a05-85e0-b2e8c18aecbb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Ensure there is an active IAM Support Role available within your AWS account. A Support Role is an IAM role configured to allow authorized users to manage incidents with AWS Support.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "IAMPolicy",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_multiple_active_accesskey_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_iam_user_first_access_key_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_security_hub_cis_enable_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_hub_cis_enable_check",
      CreatedAt: "2023-04-25 12:25:11",
      FindingId: "32f0a891-a132-49f7-b8ca-f725af62c849",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Check that the CIS AWS Foundations Benchmark v1.2.0 standard is enabled in Security Hub",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "SecurityHubHighCriticalFindings",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_password_symbol_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_symbol_check",
      CreatedAt: "2023-04-25 12:23:38",
      FindingId: "f6dbf0f4-63c5-4b6d-8949-c4299ffd50cd",
      Metadata: {
        TaskRefId: "22c1fcf3-8c9f-539a-a71f-0de35c07118f",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check identifies whether the account password policy for IAM users uses atleast one symbol.",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_user_second_access_key_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_iam_role_policies_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "024c7264-8a8e-417d-b0e2-f358068aa3f6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AWSReservedSSO_AdministratorAccess_97d110b612947114",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "07121c0b-7b0c-4bb2-9fe2-0a9fc24e050e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-KMSCMKNC-LambdaExecutionRole-ZFXJO6PRT3XR",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "21ed9cc9-12bb-4c4a-b7ea-6c1baa2141f1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "OrganizationAccountAccessRole",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "543bcced-0277-4a3a-a210-a40a422c01fe",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AWSServiceRoleForCloudTrail",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "6221c313-9df3-41bf-8e48-f4c471e7ad79",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "MontyCloud-ComplianceBotRole",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "8e32edc3-b75c-4919-b9a7-c178ce671167",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "WARtestEC2RoleNC-181570489212",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "8e9dc65d-dd46-4594-8016-896910ae2805",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "MontyCloud-AdminRole",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "a709a730-0cf0-4651-964d-5941e9d30450",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "MontyCloud-ManagedInstanceRole",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "ae5e8590-10d2-4e15-a1e6-01fca026a98a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "MontyCloud-SecurityBotRole",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_role_policies_check",
      CreatedAt: "2023-04-25 12:25:03",
      FindingId: "baf3be1d-7d00-41bd-887c-58beeb4bec7f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This rule checks whether IAM policy allows all actions on resources.",
      RegionCode: "global",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-EC2N-wartestEC2NonCompliantLa-VTUGGO4PVO9B",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 24,
};
export const Security_Q1_securityhub_foundational_security_enable_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "securityhub_foundational_security_enable_check",
      CreatedAt: "2023-04-25 12:25:11",
      FindingId: "6de440fb-674c-4015-888f-2c0af6365b40",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "Check AWS foundational Security Best Practices compliance standard is enabled in Security Hub",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "SecurityHubHighCriticalFindings",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_no_root_account_access_key_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "no_root_account_access_key_check",
      CreatedAt: "2023-04-25 12:23:41",
      FindingId: "cb1003e2-0652-42d7-b1dd-fd94b03863bf",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "It is recommended that all access keys associated with the root account are removed. Removing access keys associated with the root account limits vectors by which the account can be compromised. Additionally, removing the root access keys encourages the creation and use of role based accounts that are least privileged.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q1_iam_user_access_key_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_cognito_identity_pool_password_policy = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_cognito_temporary_password_age_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q1_iam_assume_role_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "3e3b9f6b-91f1-4b78-864a-6b60a0afadc6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6HLCRRFPIR",
      ResourceType: "IAMRole",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "16aa09bb-3ece-4d95-9040-03ae81818c1a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6FKQLBMKKH",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:58",
      FindingId: "1f484604-a90d-454e-ac98-e0568b904137",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6AZ4S22LSH",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "2fde805d-cbbd-47a8-82db-6385adb32539",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6GLWKLRLIZ",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "3a7c512d-dde6-4c1c-a3b5-e08c53515b16",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6BZCNE44CJ",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "4db22191-e763-4792-a96f-9ff3c4eee81b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6M2TETZEDO",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "586b81de-a15c-44a8-810c-af39218a7695",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6ERLYOY42M",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:58",
      FindingId: "5d31b271-91b0-4ebc-9cbd-5422c7da6ba7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6AZGDPF2DV",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "7a7fce04-9a23-4a5b-a132-e9363558e9fb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6LTLCXIVRY",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "iam_assume_role_check",
      CreatedAt: "2023-04-25 12:24:59",
      FindingId: "837062f0-0606-489b-b9b8-383e9a6f00ba",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "AssumeRole within your account is used for cross-account access. In order to follow least privilege principle, it recommended NOT to use AssumeRole across ALL the accounts",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "AROASURTRZN6H3XTZGKLV",
      ResourceType: "IAMRole",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 24,
};
export const Security_Q1_iam_password_number_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "iam_password_number_check",
      CreatedAt: "2023-04-25 12:23:38",
      FindingId: "e0b1bd9c-de5d-4186-ae22-732a363bef20",
      Metadata: {
        TaskRefId: "9dd4101c-298f-5ce0-bcfb-34b8c321a88e",
      },
      PillarId: "security",
      QuestionId: "securely-operate",
      Recommendation:
        "This check identifies whether the account password policy for IAM users uses atleast one number.",
      RegionCode: "global",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Account",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Security_Q2_Check_Details = [
  {
    CheckId: "directory_service_radius_check",
    Description: "Is RADIUS enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "secrets_manager_is_secret_auto_rotation_enabled",
    Description:
      "Secrets Manager secrets should have automatic rotation enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_instance_iam_auth_check",
    Description: "RDS DB use IAM Authentication",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cognito_identity_pool_enforce_mfa",
    Description: "Ensure Cognito Identity Pool enforce MFA",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "neptune_instance_iam_authentication_check",
    Description: "Neptune use IAM DB Auth",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "iam_user_permission_check",
    Description: "Ensure IAM Users Receive Permissions Only Through Groups",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "iam_user_mfa_check",
    Description:
      "IAM users should have Multi-Factor Authentication (MFA) enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_instance_domain_join_check",
    Description: "RDS supported DBs joined to a domain",
    ErrorMessages: null,
    Status: "FAILED",
  },
];
export const Security_Q2_directory_service_radius_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q2_secrets_manager_is_secret_auto_rotation_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q2_rds_instance_iam_auth_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_iam_auth_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "5b408e55-732c-40b9-97a2-3ed6bf61459b",
      Metadata: { TaskRefId: "698a0d10-86a5-4985-b80a-971dd06aca75" },
      PillarId: "security",
      QuestionId: "identities",
      Recommendation:
        "Authenticate to your DB cluster using AWS Identity and Access Management (IAM) database authentication. IAM database authentication works with Aurora MySQL, and Aurora PostgreSQL. With this authentication method, you don't need to use a password when you connect to a DB cluster. Instead, you use an authentication token.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_iam_auth_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "c8d4c9bf-fdaf-4c05-9a18-747286c6bd2b",
      Metadata: { TaskRefId: "698a0d10-86a5-4985-b80a-971dd06aca75" },
      PillarId: "security",
      QuestionId: "identities",
      Recommendation:
        "Authenticate to your DB cluster using AWS Identity and Access Management (IAM) database authentication. IAM database authentication works with Aurora MySQL, and Aurora PostgreSQL. With this authentication method, you don't need to use a password when you connect to a DB cluster. Instead, you use an authentication token.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q2_cognito_identity_pool_enforce_mfa = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q2_neptune_instance_iam_authentication_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_instance_iam_authentication_check",
      CreatedAt: "2023-04-25 12:24:57",
      FindingId: "abea2c6b-1b86-4fc9-8a25-afe053347d5f",
      Metadata: { TaskRefId: "f833efec-5ea2-4750-b260-c658ec8b6ab3" },
      PillarId: "security",
      QuestionId: "identities",
      Recommendation:
        "AWS Identity and Access Management (IAM) is an AWS service that helps an administrator securely control access to AWS resources. IAM administrators control who can be authenticated (signed in) and authorized (have permissions) to use Neptune resources. IAM is an AWS service that you can use with no additional charge. You can use AWS Identity and Access Management (IAM) to authenticate to your Neptune DB instance or DB cluster. When IAM database authentication is enabled, each request must be signed using AWS Signature Version 4.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "wartestrds1noncompliant-181570489212",
      ResourceType: "NeptuneInstance",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_instance_iam_authentication_check",
      CreatedAt: "2023-04-25 12:24:57",
      FindingId: "ce9e759b-3978-41c9-a802-8daa974ef31a",
      Metadata: { TaskRefId: "f833efec-5ea2-4750-b260-c658ec8b6ab3" },
      PillarId: "security",
      QuestionId: "identities",
      Recommendation:
        "AWS Identity and Access Management (IAM) is an AWS service that helps an administrator securely control access to AWS resources. IAM administrators control who can be authenticated (signed in) and authorized (have permissions) to use Neptune resources. IAM is an AWS service that you can use with no additional charge. You can use AWS Identity and Access Management (IAM) to authenticate to your Neptune DB instance or DB cluster. When IAM database authentication is enabled, each request must be signed using AWS Signature Version 4.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "NeptuneInstance",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q2_iam_user_permission_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q2_iam_user_mfa_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q2_rds_instance_domain_join_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_domain_join_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "39383717-8003-4c97-9f8c-bb73843b6038",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "identities",
      Recommendation:
        "Amazon RDS support for Kerberos and Active Directory provides the benefits of single sign-on and centralized authentication of database users. You can keep your user credentials in Active Directory. Active Directory provides a centralized place for storing and managing credentials for multiple DB instances",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_domain_join_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "e156527a-9475-433e-8302-18e1e43326ef",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "identities",
      Recommendation:
        "Amazon RDS support for Kerberos and Active Directory provides the benefits of single sign-on and centralized authentication of database users. You can keep your user credentials in Active Directory. Active Directory provides a centralized place for storing and managing credentials for multiple DB instances",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Security_Q3_Check_Details = [
  {
    CheckId: "sns_cross_account_check",
    Description: "SNS  topic cross-account access",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "lambda_admin_privilege_check",
    Description: "Lambda Functions with Admin Privileges are not created",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ecs_role_task_check",
    Description:
      "Prefer using IAM roles for tasks rather than using IAM roles for an instance",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_should_not_be_world_listable",
    Description:
      "S3 buckets with FULL_CONTROL or READ or READ_ACP permissions to public or ALL USERS",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_list_action_all_principal_check",
    Description:
      "S3 bucket policy should not allow list actions from all principals",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "does_resource_allow_external_principals",
    Description:
      "Ensure external pricipals are not now allowed, if you want to allow add it with limited permissions and conditions.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "lambda_function_public_check",
    Description: "Check for public Lambda Functions",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elastic_search_domain_public_check",
    Description: "Public Elasticsearch Domain",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "shield_advanced_drt_access_check",
    Description: "DRT (DDoS Response Team) have account authz via IAM role",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elasticache_redis_cluster_auth_token",
    Description:
      "Ensure users Authenticating with the Redis authentication tokens",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cognito_check",
    Description: "Elasticsearch Domain Cognito auth",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "emr_security_config_kerberos_check",
    Description: "EMR cluster security configs enforce Kerberos authN",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_put_action_check",
    Description:
      "S3 bucket policy should not allow put or restore actions from all principals without a condition",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "sns_public_topic_check",
    Description: "Check for public SNS Topics",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ebs_snapshot_public_check",
    Description:
      "AWS Elastic Block Store (EBS) volume snapshots must not publicly shared",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_withoutcondition_action_all_check",
    Description:
      "S3 bucket policy should not allow all actions from all principals",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_list_action_check",
    Description:
      "S3 bucket policy should not allow list actions from all principals without a condition",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_delete_action_all_principal_check",
    Description:
      "S3 bucket policy should not allow delete actions from all principals",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_should_not_be_world_writable",
    Description:
      "S3 buckets with FULL_CONTROL or WRITE or WRITE_ACP permissions to public or ALL USERS",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "glue_data_catalog_resource_policy_check",
    Description:
      "AWS Glue data catalogs should enforce fine-grained access controls with a resource policy",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ec2_iam_role_check",
    Description: "EC2 Instance Using IAM Roles",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_delete_action_check",
    Description:
      "S3 bucket policy should not allow delete actions from all principals without a condition",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ecr_public_repo_check",
    Description: "Public AWS ECR repository",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
    Description:
      "S3 buckets with FULL_CONTROL or READ or READ_ACP permissions to Autheticated Users",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "lambda_same_iam_execution_role_check",
    Description:
      "Ensure that your Amazon Lambda functions do not share the same AWS IAM execution role",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_get_action_all_principal_check",
    Description:
      "S3 bucket policy should not allow get actions from all principals",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_put_action_without_condition_check",
    Description:
      "S3 bucket policy should not allow put or restore actions from all principals",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_snapshot_public_access_check",
    Description: "RDS DB Public Snapshots",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_get_action_check",
    Description:
      "S3 bucket policy should not allow get actions from all principals without a condition",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_anonymous_user_write_check",
    Description:
      "S3 buckets with FULL_CONTROL or WRITE or WRITE_ACP permissions to Autheticated Users",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "appstream_users_use_saml_authentication",
    Description:
      "Ensure that appstream users are accessing appstream applications using SAML authetication",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_all_action_check",
    Description:
      "S3 bucket should not allow all actions from all principals without a condition",
    ErrorMessages: null,
    Status: "FAILED",
  },
];
export const Security_Q3_sns_cross_account_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "sns_cross_account_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "26df7807-2122-418b-9d95-307c42c6190f",
      Metadata: { TaskRefId: "bfc30b21-2a04-4693-b52f-2d855dc87cb8" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure SNS topics are configured to allow access only to trusted AWS accounts in order to protect against unauthorized cross-account access",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_cross_account_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "6581036d-82f2-45d6-a1ee-263e40926d6b",
      Metadata: { TaskRefId: "bfc30b21-2a04-4693-b52f-2d855dc87cb8" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure SNS topics are configured to allow access only to trusted AWS accounts in order to protect against unauthorized cross-account access",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:sns:us-east-1:181570489212:war-test-9b1e",
      ResourceType: "Topic",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_cross_account_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "71ce756a-883d-4789-aaf7-43be2c3f7ea3",
      Metadata: { TaskRefId: "bfc30b21-2a04-4693-b52f-2d855dc87cb8" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure SNS topics are configured to allow access only to trusted AWS accounts in order to protect against unauthorized cross-account access",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-OnBoarding-Topic",
      ResourceType: "Topic",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_cross_account_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "9844b76b-ada3-4130-b5e2-dbc7cce9803d",
      Metadata: { TaskRefId: "bfc30b21-2a04-4693-b52f-2d855dc87cb8" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure SNS topics are configured to allow access only to trusted AWS accounts in order to protect against unauthorized cross-account access",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q3_lambda_admin_privilege_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_admin_privilege_check",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "0da1b50a-2d8b-4759-b3a5-b12d7baa90f8",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks the lambda function having administrative privileges. Always provide the specific permissions needed by your Lambda Functions, and then craft IAM policies for these permissions only, instead of full administrative privileges",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_admin_privilege_check",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "413c0ca5-0008-4b45-8be2-d6ec2557e71e",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks the lambda function having administrative privileges. Always provide the specific permissions needed by your Lambda Functions, and then craft IAM policies for these permissions only, instead of full administrative privileges",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_admin_privilege_check",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "8315a6e8-883d-4152-9f44-a4e1d38db233",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks the lambda function having administrative privileges. Always provide the specific permissions needed by your Lambda Functions, and then craft IAM policies for these permissions only, instead of full administrative privileges",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_admin_privilege_check",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "8edd6221-da98-4050-9b52-e8fb8eacc256",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks the lambda function having administrative privileges. Always provide the specific permissions needed by your Lambda Functions, and then craft IAM policies for these permissions only, instead of full administrative privileges",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_admin_privilege_check",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "a2f957af-3553-4fd6-b7d3-d2faa16f9fa0",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks the lambda function having administrative privileges. Always provide the specific permissions needed by your Lambda Functions, and then craft IAM policies for these permissions only, instead of full administrative privileges",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_admin_privilege_check",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "dfd68ba2-2d7c-4fd9-9748-af8fb95a8445",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks the lambda function having administrative privileges. Always provide the specific permissions needed by your Lambda Functions, and then craft IAM policies for these permissions only, instead of full administrative privileges",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_ecs_role_task_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_s3_bucket_should_not_be_world_listable = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_listable",
      CreatedAt: "2023-04-25 12:23:49",
      FindingId: "2df6d116-4232-41da-b789-537b972d68b8",
      Metadata: { TaskRefId: "8d5c0be4-06e4-4048-8a1a-84d61f0f7614" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to ALL USERS. ALL USERS GROUP - Access permission to this group allows anyone in the world access to the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_listable",
      CreatedAt: "2023-04-25 12:23:49",
      FindingId: "0cc30321-ff62-4675-a353-a9ec1b452bd5",
      Metadata: { TaskRefId: "8d5c0be4-06e4-4048-8a1a-84d61f0f7614" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to ALL USERS. ALL USERS GROUP - Access permission to this group allows anyone in the world access to the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_listable",
      CreatedAt: "2023-04-25 12:23:49",
      FindingId: "2661d027-dc67-4ecf-bca3-3094f29dcd9b",
      Metadata: { TaskRefId: "8d5c0be4-06e4-4048-8a1a-84d61f0f7614" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to ALL USERS. ALL USERS GROUP - Access permission to this group allows anyone in the world access to the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_listable",
      CreatedAt: "2023-04-25 12:23:49",
      FindingId: "620bf85f-f283-4d94-83e0-6dc7c100d9e1",
      Metadata: { TaskRefId: "8d5c0be4-06e4-4048-8a1a-84d61f0f7614" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to ALL USERS. ALL USERS GROUP - Access permission to this group allows anyone in the world access to the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_listable",
      CreatedAt: "2023-04-25 12:23:49",
      FindingId: "6ae43cc1-b362-4810-b00d-2c1131f6d63c",
      Metadata: { TaskRefId: "8d5c0be4-06e4-4048-8a1a-84d61f0f7614" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to ALL USERS. ALL USERS GROUP - Access permission to this group allows anyone in the world access to the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_listable",
      CreatedAt: "2023-04-25 12:23:49",
      FindingId: "ed91db68-75f0-4b53-84f6-b1866c16bd6a",
      Metadata: { TaskRefId: "8d5c0be4-06e4-4048-8a1a-84d61f0f7614" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to ALL USERS. ALL USERS GROUP - Access permission to this group allows anyone in the world access to the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_s3_bucket_list_action_all_principal_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:55",
      FindingId: "ed5dcdb4-bfc4-4bb8-94c0-17f1a512bb45",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:55",
      FindingId: "f8a4b06e-d7bf-41b3-8b11-8c90f8f368fa",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:55",
      FindingId: "0008fd55-a1bc-4557-9867-90c664101484",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:55",
      FindingId: "33c78ead-3281-4c57-814f-abf83336efd8",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:55",
      FindingId: "64a9fd61-9531-46d4-aa1b-69d59ec4c562",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:55",
      FindingId: "6ef7c6d2-a112-4e3b-9f88-044d32a1b276",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_does_resource_allow_external_principals = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_lambda_function_public_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_public_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "0f564160-c192-4a3e-9122-32222bcdcdf9",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify any publicly accessible Amazon Lambda functions and update their access policy in order to protect against unauthorized users that are sending requests to invoke these functions.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q3_elastic_search_domain_public_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_shield_advanced_drt_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "shield_advanced_drt_access_check",
      CreatedAt: "2023-04-25 12:24:55",
      FindingId: "dab0e8d7-24af-4e8e-a91d-25113ff45a70",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure DDOS Response Team have account authz via IAM role",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "Shield",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q3_elasticache_redis_cluster_auth_token = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_cognito_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_emr_security_config_kerberos_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_s3_bucket_put_action_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "2341696e-7bad-4ae7-b26a-6b313c7b0930",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "629a96fd-3397-4204-b709-77f42db85501",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "18e8419f-1ed7-499d-a7d5-dfff7b1bd706",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "e1413760-df5e-4a05-a786-f88f60dd53ef",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "f3e8b467-aaa4-4448-b019-1c223113127c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "f88ba54e-5dfd-4ff8-8a8c-d49eadd1f6c8",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_sns_public_topic_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "sns_public_topic_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "02156156-50b8-402e-afa9-9527436968d3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify any publicly accessible Amazon SNS topics and update their permissions in order to protect against attackers and unauthorized personnel.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_public_topic_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "55ad8b0c-8720-4501-b5ba-d52bc7de58ab",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify any publicly accessible Amazon SNS topics and update their permissions in order to protect against attackers and unauthorized personnel.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:sns:us-east-1:181570489212:war-test-9b1e",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_public_topic_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "8c54a32b-415f-4031-b1e1-adfd8de7a442",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify any publicly accessible Amazon SNS topics and update their permissions in order to protect against attackers and unauthorized personnel.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_public_topic_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "485e6f36-fe47-4ae4-99b7-ba1f65f75642",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify any publicly accessible Amazon SNS topics and update their permissions in order to protect against attackers and unauthorized personnel.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-OnBoarding-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q3_ebs_snapshot_public_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_public_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "406c0d82-44e9-4ae7-9826-853649079e3f",
      Metadata: { TaskRefId: "14d51cb3-80ca-4cf1-ad97-f92fc5998a00" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify EBS snapshots are not public, public snapshots are shared with other AWS accounts which can lead to exposing data resides in the snapshot.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "snap-0fefb040fa59d91ac",
      ResourceType: "Snapshot",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_public_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "c35fc1c5-7a09-4170-a599-169f7851bce2",
      Metadata: { TaskRefId: "14d51cb3-80ca-4cf1-ad97-f92fc5998a00" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Identify EBS snapshots are not public, public snapshots are shared with other AWS accounts which can lead to exposing data resides in the snapshot.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "snap-08155855243ecf2be",
      ResourceType: "Snapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};

export const Security_Q3_s3_bucket_withoutcondition_action_all_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_withoutcondition_action_all_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "44da3ccc-a3c0-4d77-90c5-6ea37752545a",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_withoutcondition_action_all_check",
      CreatedAt: "2023-04-25 12:24:02",
      FindingId: "5f6672ed-2b5e-42e1-9595-3c407d6017da",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_withoutcondition_action_all_check",
      CreatedAt: "2023-04-25 12:24:02",
      FindingId: "0a7adfcb-21ea-4297-b576-2440b7a5e9dd",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_withoutcondition_action_all_check",
      CreatedAt: "2023-04-25 12:24:02",
      FindingId: "2152c747-a04a-495a-8eff-92e9cc361cf4",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_withoutcondition_action_all_check",
      CreatedAt: "2023-04-25 12:24:02",
      FindingId: "80d26161-ebe0-4006-b3d3-def2730eed78",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_withoutcondition_action_all_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "ba5bb1cf-b722-4cb1-a385-d5841380cbcb",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_s3_bucket_list_action_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "533a0d97-9e64-4766-b4ae-a275852938b6",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "b63a88f3-fab1-4a5e-8a25-e4d7252f015d",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "16036d81-0d15-4804-a619-511cf544c0cc",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "30a729f6-943f-440e-b496-a91910e80a3c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "3c12c6a8-7a18-4810-8664-c286f4731b10",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "5e304af6-b0eb-4534-a4ea-f7e65a847730",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "afc45b0e-2ffd-4b72-a0a2-7850ca004239",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "cba07e12-2824-4c2f-bc94-83593071994a",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "dc03cd73-415c-406d-9cfe-c0ec36120bea",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_list_action_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "de4535a6-ed46-43c0-8e61-bfa4f57d8b09",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if list action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 10,
};
export const Security_Q3_s3_bucket_delete_action_all_principal_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "18245a43-64c9-4d6f-a2f5-b16f85d0a5aa",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "80cb1e7e-ea1d-4e75-8e44-40fccc773c2a",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "0aa21ce0-9c34-4a38-9af7-ec8ffb50b04e",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "537ddd36-a61e-48f2-95fa-bd415bdffaa1",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "65588641-48e4-4326-9cf5-ab5267402360",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_all_principal_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "e780202c-4757-45a5-94a9-4858be2ad79e",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_s3_bucket_should_not_be_world_writable = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_writable",
      CreatedAt: "2023-04-25 12:23:50",
      FindingId: "14791095-9730-4807-936a-6a99db602bd9",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to everyone. ALL USERS GROUP \u2013 Access permission to this group allows anyone in the world access to the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_writable",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "4c60f95a-b5e1-45a4-998f-eb8b0e9f3cb8",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to everyone. ALL USERS GROUP \u2013 Access permission to this group allows anyone in the world access to the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_writable",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "77393e51-7efc-4850-907b-141fc3c2bc0c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to everyone. ALL USERS GROUP \u2013 Access permission to this group allows anyone in the world access to the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_writable",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "c120e087-7f05-4944-9e62-ea7b649fe614",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to everyone. ALL USERS GROUP \u2013 Access permission to this group allows anyone in the world access to the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_writable",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "c892c3b8-8282-43b7-9332-cbea3f5f9397",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to everyone. ALL USERS GROUP \u2013 Access permission to this group allows anyone in the world access to the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_should_not_be_world_writable",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "f1675038-10c6-40ff-852f-ee1cf9ccfbf3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to everyone. ALL USERS GROUP \u2013 Access permission to this group allows anyone in the world access to the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_glue_data_catalog_resource_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "glue_data_catalog_resource_policy_check",
      CreatedAt: "2023-04-25 12:25:06",
      FindingId: "23132870-930d-4f18-b7e1-855bbce04245",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "AWS Glue data catalogs should enforce fine-grained access controls with a resource policy",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "GlueDataCatalog",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q3_ec2_iam_role_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_iam_role_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "2396452e-d626-4e97-a2ba-56442b40b2e3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if roles are attached to EC2 instance, Use IAM Roles/Instance Profiles instead of IAM Access Keys to appropriately grant access permissions to any application that perform AWS API requests running on your Amazon EC2 instances",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0eb9f9cc0b178be09",
      ResourceType: "Instance",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_iam_role_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "ab851007-81bb-4b18-963d-24fc96a320b9",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if roles are attached to EC2 instance, Use IAM Roles/Instance Profiles instead of IAM Access Keys to appropriately grant access permissions to any application that perform AWS API requests running on your Amazon EC2 instances",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-04b1c4e4f9284d09a",
      ResourceType: "Instance",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_iam_role_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "cd0fa941-9dbd-4e4d-a36a-fde599f013e2",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if roles are attached to EC2 instance, Use IAM Roles/Instance Profiles instead of IAM Access Keys to appropriately grant access permissions to any application that perform AWS API requests running on your Amazon EC2 instances",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0e72da0097f2af649",
      ResourceType: "Instance",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 3,
};
export const Security_Q3_s3_bucket_delete_action_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_check",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "4f996c1e-8c70-4fb4-bc81-76ff61ed9997",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_check",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "cbc19c16-75dd-4757-a034-7561442b1e26",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_check",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "07aafc35-d779-43ae-8932-522c4ae9e520",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_check",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "59172ca6-f54d-4d04-9e9c-7cd7b099e144",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_check",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "8e471911-5176-4142-9e42-2d57c11416f7",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_delete_action_check",
      CreatedAt: "2023-04-25 12:23:51",
      FindingId: "f32f7b47-e92f-4ebf-9f85-6def7f7eef91",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if delete actions from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};

export const Security_Q3_ecr_public_repo_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ecr_public_repo_check",
      CreatedAt: "2023-04-25 12:24:49",
      FindingId: "a3352158-4e70-439f-a762-a088c9d4a0fb",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "AWS ECR is a managed Docker registry service that simplifies Docker container image management. The ECR repository is a collection of Docker images available on AWS. Access control to ECR repositories is governed using resource-based policies. A public ECR repository can expose internal Docker images that contain confidential business logic.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ecr:us-east-1:181570489212:repository/warf-repo-ba272900-e354-11ed-860e-0e88695980d3",
      ResourceType: "Repository",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Security_Q3_s3_bucket_should_not_be_world_listable_by_anonymous_user =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [
      {
        AccountNumber: "181570489212",
        CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
        CreatedAt: "2023-04-25 12:23:50",
        FindingId: "3f798e8e-61af-41c1-bb15-7f166d012eda",
        Metadata: { TaskRefId: null },
        PillarId: "security",
        QuestionId: "permissions",
        Recommendation:
          "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to Autheticated users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
        ResourceType: "S3",
        Severity: "Critical",
        Status: "Failed",
      },
      {
        AccountNumber: "181570489212",
        CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
        CreatedAt: "2023-04-25 12:23:50",
        FindingId: "43dfdf39-53ce-43c8-a604-78b49169baa6",
        Metadata: { TaskRefId: null },
        PillarId: "security",
        QuestionId: "permissions",
        Recommendation:
          "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to Autheticated users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId:
          "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
        ResourceType: "S3",
        Severity: "Informational",
        Status: "Passed",
      },
      {
        AccountNumber: "181570489212",
        CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
        CreatedAt: "2023-04-25 12:23:50",
        FindingId: "62538a75-8786-4f5d-b4ba-987940c43ef2",
        Metadata: { TaskRefId: null },
        PillarId: "security",
        QuestionId: "permissions",
        Recommendation:
          "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to Autheticated users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId:
          "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
        ResourceType: "S3",
        Severity: "Informational",
        Status: "Passed",
      },
      {
        AccountNumber: "181570489212",
        CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
        CreatedAt: "2023-04-25 12:23:50",
        FindingId: "ad7681b3-36cc-4c27-beda-b1f43b02acf2",
        Metadata: { TaskRefId: null },
        PillarId: "security",
        QuestionId: "permissions",
        Recommendation:
          "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to Autheticated users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
        ResourceType: "S3",
        Severity: "Informational",
        Status: "Passed",
      },
      {
        AccountNumber: "181570489212",
        CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
        CreatedAt: "2023-04-25 12:23:50",
        FindingId: "af44c721-83f0-4ddb-b671-62fbefe842e1",
        Metadata: { TaskRefId: null },
        PillarId: "security",
        QuestionId: "permissions",
        Recommendation:
          "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to Autheticated users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
        ResourceType: "S3",
        Severity: "Informational",
        Status: "Passed",
      },
      {
        AccountNumber: "181570489212",
        CheckId: "s3_bucket_should_not_be_world_listable_by_anonymous_user",
        CreatedAt: "2023-04-25 12:23:50",
        FindingId: "c2b7b661-bc70-4a95-a65b-dee45354e8f6",
        Metadata: { TaskRefId: null },
        PillarId: "security",
        QuestionId: "permissions",
        Recommendation:
          "This check identifies S3 buckets which have acl that grants FULL_CONTROL or READ or READ_ACP permission to Autheticated users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource. PERMISSION READ: Allows grantee to list the objects in the bucket and when granted on a bucket and Allows grantee to read the object data and its metadata, when granted on an object. | PERMISSION READ_ACP: Allows grantee to read the bucket ACL, when granted on a bucket and Allows grantee to read the object ACL, when granted on an object. | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
        ResourceType: "S3",
        Severity: "Informational",
        Status: "Passed",
      },
    ],
    TotalRecords: 6,
  };

export const Security_Q3_lambda_same_iam_execution_role_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_same_iam_execution_role_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "290323fb-f4f2-4536-aaa6-16f9a22f9258",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Amazon Lambda functions do not share the same execution role in order to promote the Principle of Least Privilege by providing each individual function the minimal amount of access required to perform its tasks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_same_iam_execution_role_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "ea0bf78c-2ad6-40fe-b7f1-2770fe3b610c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Amazon Lambda functions do not share the same execution role in order to promote the Principle of Least Privilege by providing each individual function the minimal amount of access required to perform its tasks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_same_iam_execution_role_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "0fcd43d5-50a9-4c68-8244-9918d70c3ce3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Amazon Lambda functions do not share the same execution role in order to promote the Principle of Least Privilege by providing each individual function the minimal amount of access required to perform its tasks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_same_iam_execution_role_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "0fdb5319-700f-4caa-9f94-362a4860681f",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Amazon Lambda functions do not share the same execution role in order to promote the Principle of Least Privilege by providing each individual function the minimal amount of access required to perform its tasks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_same_iam_execution_role_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "cd187d24-5047-4801-ae18-157c11dfc869",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Amazon Lambda functions do not share the same execution role in order to promote the Principle of Least Privilege by providing each individual function the minimal amount of access required to perform its tasks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_same_iam_execution_role_check",
      CreatedAt: "2023-04-25 12:24:22",
      FindingId: "dc0482f0-2648-499c-a6ce-4846bbd7f635",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Amazon Lambda functions do not share the same execution role in order to promote the Principle of Least Privilege by providing each individual function the minimal amount of access required to perform its tasks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};

export const Security_Q3_s3_bucket_get_action_all_principal_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_all_principal_check",
      CreatedAt: "2023-04-25 12:24:00",
      FindingId: "544208f1-d3eb-47f0-9cc0-4196a1446297",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_all_principal_check",
      CreatedAt: "2023-04-25 12:24:00",
      FindingId: "dc1951f3-46ee-45ed-af0e-8d04e0481728",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_all_principal_check",
      CreatedAt: "2023-04-25 12:24:00",
      FindingId: "311dc5f5-c63a-43e5-9c1b-394e4c473c01",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_all_principal_check",
      CreatedAt: "2023-04-25 12:24:00",
      FindingId: "554f5169-f7b5-4710-be46-6c6435d2df4b",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_all_principal_check",
      CreatedAt: "2023-04-25 12:24:00",
      FindingId: "7164ecfd-5b70-4894-8041-561ef0010342",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_all_principal_check",
      CreatedAt: "2023-04-25 12:24:00",
      FindingId: "9c3e746d-c136-4787-9146-b537fc5b606c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};

export const Security_Q3_s3_bucket_put_action_without_condition_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_without_condition_check",
      CreatedAt: "2023-04-25 12:23:58",
      FindingId: "85b0321c-372f-46ac-856e-04ae0712ace1",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_without_condition_check",
      CreatedAt: "2023-04-25 12:23:58",
      FindingId: "b663c8e0-ec3d-4bd6-8b04-6ca4f8b6e5b3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_without_condition_check",
      CreatedAt: "2023-04-25 12:23:58",
      FindingId: "41f2a855-945a-4de0-903a-c7b167840a4a",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_without_condition_check",
      CreatedAt: "2023-04-25 12:23:58",
      FindingId: "9f6b5fb8-5e2d-4a87-8a3e-c9cc9e86b490",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_without_condition_check",
      CreatedAt: "2023-04-25 12:23:58",
      FindingId: "a0ba12ec-37dc-4c9d-abe9-5c1976420570",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_put_action_without_condition_check",
      CreatedAt: "2023-04-25 12:23:58",
      FindingId: "b4bbddbe-9329-4bea-bf1c-fedad53d66a0",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if put action from all principals is allowed on S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_rds_snapshot_public_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_snapshot_public_access_check",
      CreatedAt: "2023-04-25 12:24:48",
      FindingId: "c6b517b8-5dcc-4327-b22b-e93182e5fdb7",
      Metadata: { TaskRefId: "6480dac2-db43-4c93-b451-ec23abd9df5f" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Relational Database Service (RDS) database snapshots are not publicly accessible (i.e. shared with all AWS accounts and users) in order to avoid exposing your private data.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "wafr-rdsnc-snapshot-a37edcf9-8490-4d5d-ba89-cc0df9cc4534",
      ResourceType: "RdsSnapshot",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_snapshot_public_access_check",
      CreatedAt: "2023-04-25 12:24:48",
      FindingId: "0f9b2856-c06e-4e46-92f0-f07d4de3e85d",
      Metadata: { TaskRefId: "6480dac2-db43-4c93-b451-ec23abd9df5f" },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Ensure that your Relational Database Service (RDS) database snapshots are not publicly accessible (i.e. shared with all AWS accounts and users) in order to avoid exposing your private data.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "wartestrds1noncompliant-181570489212-final-snapshot",
      ResourceType: "RdsSnapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q3_s3_bucket_get_action_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "2ba87ef7-45af-4c61-a598-d4a700f239d3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "e546295c-d935-4517-ac9b-b8d6c8ec707a",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "47977b01-d600-4578-b464-85b2eef16add",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "61c8c177-94cd-44a0-b853-60e55b1afa78",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "8c4e614f-5cf9-456e-95fa-bb8fcb8ef840",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "aa99acb3-450c-4239-9ded-3a516bc49b28",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "ad62cbf9-15f3-47df-9845-2c79bcaf4517",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "ddd8e290-f517-4fd1-96f9-6ba24f8f5cb5",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "e16dcbcb-1005-4571-93ff-ecad6df8ac08",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_get_action_check",
      CreatedAt: "2023-04-25 12:23:54",
      FindingId: "eddbfa49-e6f5-4b51-899c-b9da587d2026",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This rule checks if get action from all principals is allowed on S3 buckets without a condition.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 10,
};
export const Security_Q3_s3_bucket_anonymous_user_write_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_anonymous_user_write_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "106c180d-0ef5-4f6b-b319-b00be98f0419",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to Autheticated Users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_anonymous_user_write_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "26705453-352b-4131-99cd-8b2f1f52e7d8",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to Autheticated Users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_anonymous_user_write_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "4b939805-ca45-4f0a-8682-d929a3765a0e",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to Autheticated Users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_anonymous_user_write_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "70a50225-43ee-4872-ba8b-c2e6a515db1d",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to Autheticated Users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_anonymous_user_write_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "7b2d9619-fa82-427c-9206-912cc0af0da3",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to Autheticated Users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_anonymous_user_write_check",
      CreatedAt: "2023-04-25 12:23:56",
      FindingId: "bcc5aaf9-5713-49c4-99e9-f25c304817fe",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "This check identifies S3 buckets which have acl that grants FULL_CONTROL or WRITE or WRITE_ACP permission to Autheticated Users. AUTHENTICATED USERS GROUP - This group represents all AWS accounts. Access permission to this group allows any AWS account to access the resource | PERMISSION WRITE: Allows grantee to create new objects in the bucket. For the bucket and object owners of existing objects allows deletions and overwrites of those objects, when granted on a bucket and Not applicable, when granted on an object | PERMISSION WRITE_ACP: Allows grantee to write the ACL for the applicable bucket, when granted on a bucket and Allows grantee to write the ACL for the applicable object, when granted on an object | PERMISSION FULL_CONTROL: Allows grantee the READ, WRITE, READ_ACP, and WRITE_ACP permissions on the bucket, when granted on a bucket and Allows grantee the READ, READ_ACP, and WRITE_ACP permissions on the object, when granted on an object.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q3_appstream_users_use_saml_authentication = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q3_s3_bucket_all_action_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "663b9262-8a7e-44ae-a9ed-70824d5556ee",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "bfb4c918-3f7b-4fc3-9ae4-1e45516df57c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "03eaf4f2-969d-44bf-a82c-58d434eb056c",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "1c298c20-12d0-4697-9b4a-b97fdc0c7ef4",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "1d6ab6ff-5a1a-4d09-9b06-0a15170933b9",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "52ddbf07-81e7-434d-a947-b6e0b6e1714b",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "926a91ec-5784-4066-86cb-49df47dcab37",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "ca0d6360-9b07-4cfc-b30c-b285e76f480f",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "d5b117f3-d88e-4a67-8b14-60d4eec6d36b",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_all_action_check",
      CreatedAt: "2023-04-25 12:24:01",
      FindingId: "e454cc3c-5ae8-4e49-bb79-8d8f73311348",
      Metadata: { TaskRefId: null },
      PillarId: "security",
      QuestionId: "permissions",
      Recommendation:
        "Misconfigured S3 buckets can leak private information to the entire internet or allow unauthorized data tampering / deletion. S3 bucket policy should ensure that principal of least privilege is being followed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 10,
};

export const Security_Q4_Check_Details = [
  {
    CheckId: "broker_general_logging_check",
    Description:
      "Amazon MQ Message brokers should have general logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_unauthorized_api_call_changes",
    Description:
      "Ensure a log metric filter and alarm exist for unauthorized API calls",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_iam_policy_changes",
    Description:
      "Ensure a log metric filter and alarm exist for IAM policy changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "documentdb_cluster_audit_logging_on",
    Description: "Ensure DocDB cluster audit logging is turned on",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_log_file_validation",
    Description: "CloudTrail log file validation must be enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elb_access_logging_check",
    Description: "ELBv2 has access logs enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elbv2_nlb_tls_logging_check",
    Description: "Do NLBs with TLS listeners have access logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "redshift_cluster_logging_check",
    Description: "Redshift cluster audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_cloudwatch_logging_enabled",
    Description:
      "Ensure CloudWatch logging enabled for CodeBuild for audit pupose.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "kms_key_rotation_enabled",
    Description: "Enable Key Rotation for KMS customer master key",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "emr_cluster_logging_check",
    Description: "EMR cluster logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_aws_config_changes",
    Description:
      "Ensure a log metric filter and alarm exist for AWS Config configuration changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "clb_access_logging_check",
    Description: "Classic Load Balancer logging should be enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_security_group_changes",
    Description:
      "Ensure a log metric filter and alarm exist for security group changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "high_critical_findings",
    Description:
      "Security Hub should not have active high or critical severity findings from AWS services",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_s3_bucket_publicly_accessible_check",
    Description: "CloudTrail Public buckets",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_route_table_changes",
    Description:
      "Ensure a log metric filter and alarm exist for route table changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_stage_api_logging_enabled",
    Description: "Ensure stage API logging enabled on API Gateway",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "are_global_management_events_logged",
    Description:
      'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "neptune_cluster_audit_logging_check",
    Description: "Neptune audit logging enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "blockchain_fabric_peer_node_logs_enabled",
    Description:
      "Peer node logs allow you to debug timeout errors associated with proposals and identify rejected proposals",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloudtrail_logs_encrypted_at_rest",
    Description: "CloudTrail logs are encrypted at rest using SSE-KMS",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloud_trail_multi_region",
    Description: "AWS CloudTrail must be enabled with multi-region option",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kinesis_kms_key_rotation_check",
    Description: "AWS Kinesis Streams Keys are rotated",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_cloudwatch_log_forwarding_enabled",
    Description:
      "Ensure log forwarding enabled on Directory Service directory, this helps you to meet your security monitoring, audit, and log retention policy requirements by providing transparency of the security events in your directory.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_instance_cloudwatch_logging_check",
    Description: "Enable CloudWatch logging for RDS databases ",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_network_gateway_changes",
    Description:
      "Ensure a log metric filter and alarm exist for changes to network gateways",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "amb_fabric_member_ca_logging_check",
    Description: "Fabric member CA logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "appmesh_logging_check",
    Description:
      "App Mesh virtual nodes should define an HTTP access log path to enable log exports for Envoy proxies",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_detective_enabled",
    Description:
      "Amazon Detective automatically collects log data from your AWS resources and uses machine learning (ML), statistical analysis, and graph theory to build a linked dataset that you can use to conduct more efficient security investigations.",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_enable_mfa_delete_check",
    Description: "Ensure MFA Delete is enable on S3 buckets",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_cmk_api_call_changes",
    Description:
      "Ensure a log metric filter and alarm exist for disabling or scheduled deletion of customer managed keys",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_vpc_changes",
    Description: "Ensure a log metric filter and alarm exist for VPC changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "amb_fabric_node_chaincode_logging_check",
    Description: "Fabric peer node chaincode logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "configuration_status_check",
    Description: "AWS Config is enabled in all regions",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "documentdb_cluster_audit_logs_check",
    Description: "Audit logs are enabled for DocumentDB clusters",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "vpc_flow_log_enabled_check",
    Description: "Ensure VPC flow logging is enabled in all VPCs",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kinesis_analytics_application_log_to_cloudwatch_check",
    Description: "Kinesis analytics application log to CloudWatch",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_logging_enable",
    Description: "S3 bucket server access logging should be enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_without_mfa_signin_changes",
    Description:
      "Ensure a log metric filter and alarm exist for Management Console sign-in without MFA",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloud_trail_cloud_watch_log_enabled",
    Description:
      "Ensure CloudTrail trails are integrated with Amazon CloudWatch Logs",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "broker_audit_logging_check",
    Description: "Amazon MQ Message brokers should have audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_s3_changes",
    Description:
      "Ensure a log metric filter and alarm exist for S3 bucket policy changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_console_authentication_failure",
    Description:
      "Ensure a log metric filter and alarm exist for AWS Management Console authentication failures",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "vpc_route_resolver_query_check",
    Description: "Route53 resolver Query Logging",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "eks_cluster_control_plane_logging_check",
    Description: "Amazon Elastic Kubernetes Service (EKS) cluster logging",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "documentdb_cluster_delete_protection_check",
    Description: "DocumentDB Cluster deletion protected",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_aws_cloud_trail_changes",
    Description:
      "Ensure a log metric filter and alarm exist for CloudTrail configuration changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "api_gateway_access_logging_check",
    Description: "API Gateway Stage has access logging enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "api_gateway_stage_metrics_enabled_check",
    Description: "API Gateway stage metrics enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "compromise_appstream_user_check",
    Description: "Appstream users reported as Compromised",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ecs_cluster_registration_check",
    Description:
      "Ensure that at least one instance is registered with an ECS Cluster",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_root_account_changes",
    Description:
      "Ensure a log metric filter and alarm exist for usage of root user",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_nacl_changes",
    Description:
      "Ensure a log metric filter and alarm exist for changes to Network Access Control Lists (NACL)",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloudtrail_mfa_delete_check",
    Description: "CloudTrail Bucket MFA Delete Enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Security_Q4_broker_general_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Security_Q4_log_metric_filter_for_unauthorized_api_call_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_unauthorized_api_call_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "00a805b4-2808-4208-9817-1ae9c74d4620",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm unauthorized API calls is present. Monitoring unauthorized API calls helps reveal application errors and might reduce time to detect malicious activity.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Security_Q4_log_metric_filter_for_iam_policy_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_iam_policy_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "ec6691bf-1d9f-4e45-851c-3f18711d507a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes made to IAM policies is present. Monitoring these changes helps ensure that authentication and authorization controls remain intact",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "LogMetricFilter",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Security_Q4_documentdb_cluster_audit_logging_on = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Security_Q4_cloud_trail_log_file_validation = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_log_file_validation",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "9ff83e80-435b-48a2-b56c-cd21977f64f2",
      Metadata: {
        TaskRefId: "55cf621d-04c8-4712-96f5-cbfa751d5439",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "CloudTrail log file validation creates a digitally signed digest file that contains a hash of each log that CloudTrail writes to Amazon S3. You can use these digest files to determine whether a log file was changed, deleted, or unchanged after CloudTrail delivered the log. This check verifies if CloudTrail log file validation is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_log_file_validation",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "dd4a24a9-5bf2-43bd-af7e-9520f2ebd712",
      Metadata: {
        TaskRefId: "55cf621d-04c8-4712-96f5-cbfa751d5439",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "CloudTrail log file validation creates a digitally signed digest file that contains a hash of each log that CloudTrail writes to Amazon S3. You can use these digest files to determine whether a log file was changed, deleted, or unchanged after CloudTrail delivered the log. This check verifies if CloudTrail log file validation is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_elb_access_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elb_access_logging_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "557fbfec-d2bd-4bc3-9a62-4963f71b18c0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control check whether the logging is enabled on ELBv2",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb",
      ResourceType: "LoadBalancer",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_elbv2_nlb_tls_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_redshift_cluster_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_is_cloudwatch_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_kms_key_rotation_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "kms_key_rotation_enabled",
      CreatedAt: "2023-04-25 12:25:08",
      FindingId: "bc53b0fb-bfc9-4e78-a895-08671555d389",
      Metadata: {
        TaskRefId: "12d51cb5-80ca-4cf1-ad97-f92fc5998a01",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Cryptographic best practices discourage extensive reuse of encryption keys. When you enable automatic key rotation for a KMS key, AWS KMS generates new cryptographic material for the KMS key every year. This check verifies if KMS Key rotation is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "66d0e6fe-1ae2-4919-85b8-6966f7e2c1c7",
      ResourceType: "KMSKey",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_emr_cluster_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_log_metric_filter_for_aws_config_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_aws_config_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "89450bba-9793-4b52-88b1-69ddf15dff71",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to AWS Config configuration settings is present. Monitoring these changes helps ensure sustained visibility of configuration items in the account.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_clb_access_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_log_metric_filter_for_security_group_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_security_group_changes",
      CreatedAt: "2023-04-25 12:23:42",
      FindingId: "a52a1bc1-f3e2-4df6-8e64-ed8dfb6d100f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to security groups present. Monitoring these changes helps ensure that resources and services aren't unintentionally exposed.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_high_critical_findings = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "high_critical_findings",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "c14e1fce-1207-42e1-a846-4cc236e442b4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation: "Security Hub High Critical Findings Located",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "SecurityHubHighCriticalFindings",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_cloud_trail_s3_bucket_publicly_accessible_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_publicly_accessible_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "0590318f-a869-413c-922a-2381101106d9",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Check for any publicly accessible CloudTrail trail log buckets (i.e. target buckets) in order to determine if your AWS cloud account could be at risk",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_publicly_accessible_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "0ffebc5b-fd89-4352-ba4d-77eaa91b71a7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Check for any publicly accessible CloudTrail trail log buckets (i.e. target buckets) in order to determine if your AWS cloud account could be at risk",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_log_metric_filter_for_route_table_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_route_table_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "3df28daf-b95e-47fa-be5f-22f78eae4e4b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to route tables is present. Monitoring these changes helps ensure that all VPC traffic flows through an expected path.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_is_stage_api_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "219e9daf-762d-41c1-b8b5-1012f13d1cf5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "fc3dc774-0a1e-4c7c-852e-4f08c356b633",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_are_global_management_events_logged = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "0e5bdf55-936c-4dda-8b62-18c0ba45c9cc",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "6d900d6c-f858-4e57-a692-e3090518b5bc",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_neptune_cluster_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_cluster_audit_logging_check",
      CreatedAt: "2023-04-25 12:24:43",
      FindingId: "cb9955f4-753c-4495-b526-8a1b3a7f40a0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "To audit Amazon Neptune DB cluster activity, enable the collection of audit logs by setting a DB cluster parameter. When audit logs are enabled, you can use it to log any combination of supported events. You can view or download the audit logs to review them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbclusternc-h0etehondbyg",
      ResourceType: "NeptuneCluster",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_blockchain_fabric_peer_node_logs_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_cloudtrail_logs_encrypted_at_rest = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloudtrail_logs_encrypted_at_rest",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "510c4742-5501-4cee-a80f-52da6e503e33",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your CloudTrail logs are encrypted at rest using server-side encryption provided by AWS KMS–Managed Keys (SSE-KMS) to enhance the security of your CloudTrail bucket and allow you to have better control over who can read the log files in your organization",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloudtrail_logs_encrypted_at_rest",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "8fcfd130-07b2-4586-9834-c25bc55b030d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your CloudTrail logs are encrypted at rest using server-side encryption provided by AWS KMS–Managed Keys (SSE-KMS) to enhance the security of your CloudTrail bucket and allow you to have better control over who can read the log files in your organization",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_cloud_trail_multi_region = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_multi_region",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "9c7f34d2-c9ed-44fd-b04f-af81aea9df37",
      Metadata: {
        TaskRefId: "73b2405d-d8d6-481f-b197-c9399ac0cd00",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "To ensure that you log global service events and capture all management event activity in your AWS account, you should create trails that log events in all AWS Regions. This check verifies if multi-region option is enabled for your AWS CloudTrail.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_multi_region",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "e243284c-e51c-4156-ad54-4041ea3cb674",
      Metadata: {
        TaskRefId: "73b2405d-d8d6-481f-b197-c9399ac0cd00",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "To ensure that you log global service events and capture all management event activity in your AWS account, you should create trails that log events in all AWS Regions. This check verifies if multi-region option is enabled for your AWS CloudTrail.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_kinesis_kms_key_rotation_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "kinesis_kms_key_rotation_check",
      CreatedAt: "2023-04-25 12:24:15",
      FindingId: "06cfd9f1-33fb-4fe5-9f27-5d88f6b292db",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Rotate the keys of your Kinesis Streams in order to protect your data and metadata from breaches or unauthorized access, and fulfill compliance requirements for key management within your organization.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "warf-stream-ba174a80-e354-11ed-8812-0e70d921958f",
      ResourceType: "Kinesis",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_is_cloudwatch_log_forwarding_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_rds_instance_cloudwatch_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "1679d843-74ec-423a-aaf4-b0b8cabed503",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines.  This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "9d19a57c-398c-4d4f-8e55-d151b96ac36a",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines.  This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_log_metric_filter_for_network_gateway_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_network_gateway_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "737e469f-f031-4b23-b83d-75ef9e406eed",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to network gateways is present. Monitoring these changes helps ensure that all ingress and egress traffic traverses the VPC border via a controlled path.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_amb_fabric_member_ca_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_appmesh_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_is_detective_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_detective_enabled",
      CreatedAt: "2023-04-25 12:24:48",
      FindingId: "d3b33958-ff6e-41d6-b51a-dbef8a2f234c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Amazon Detective automatically collects log data from your AWS resources and uses machine learning (ML), statistical analysis, and graph theory to build a linked dataset that you can use to conduct more efficient security investigations.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "Detective",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_s3_enable_mfa_delete_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_enable_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:53",
      FindingId: "646b3992-088b-4458-b8a6-bebb52349d62",
      Metadata: {
        TaskRefId: "415cde78-ec22-409d-b844-1138d3373d4e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your Amazon S3 buckets are configured to use the Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of versioned S3 objects available within your buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_enable_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:53",
      FindingId: "6a1c4b17-e090-4bd6-bfed-fe868a531716",
      Metadata: {
        TaskRefId: "415cde78-ec22-409d-b844-1138d3373d4e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your Amazon S3 buckets are configured to use the Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of versioned S3 objects available within your buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_enable_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:53",
      FindingId: "7adb1f12-45ca-475f-9682-c070202efe73",
      Metadata: {
        TaskRefId: "415cde78-ec22-409d-b844-1138d3373d4e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your Amazon S3 buckets are configured to use the Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of versioned S3 objects available within your buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_enable_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:53",
      FindingId: "93005169-c32f-43ea-8eca-bb8aa1c3c31e",
      Metadata: {
        TaskRefId: "415cde78-ec22-409d-b844-1138d3373d4e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your Amazon S3 buckets are configured to use the Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of versioned S3 objects available within your buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_enable_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:53",
      FindingId: "b7017624-672b-4a58-b572-ea75a9a1857e",
      Metadata: {
        TaskRefId: "415cde78-ec22-409d-b844-1138d3373d4e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your Amazon S3 buckets are configured to use the Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of versioned S3 objects available within your buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_enable_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:53",
      FindingId: "cad3182d-5eaf-443a-a11e-0283150138a8",
      Metadata: {
        TaskRefId: "415cde78-ec22-409d-b844-1138d3373d4e",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your Amazon S3 buckets are configured to use the Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of versioned S3 objects available within your buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q4_log_metric_filter_for_cmk_api_call_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_cmk_api_call_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "2cf6b054-bafa-4500-87d2-f1b2c3c60cc6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure a log metric filter and alarm exist for disabling or scheduled deletion of customer managed keys",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_log_metric_filter_for_vpc_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_vpc_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "01ab4bb8-e50f-4006-9f51-93534005e6f3",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to VPCs is present. Monitoring these changes helps ensure that authentication and authorization controls remain intact",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_amb_fabric_node_chaincode_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_configuration_status_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_documentdb_cluster_audit_logs_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_vpc_flow_log_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "4400e3c7-4a12-4a17-9e4e-078fef59bf98",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d2474fa5d3855b82",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "6fd1808b-629e-4114-a511-9f054a254fb5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0bdc428505f6126ff",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "92cf01b6-f28c-419e-bdd9-8afb1c516a4b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0ead93409c28ef71f",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "976bf7ce-0a33-4ef6-91d8-1e6be74c367d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d8fcaa7ed8e6b2a1",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q4_kinesis_analytics_application_log_to_cloudwatch_check =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [],
    TotalRecords: 0,
  };
export const Security_Q4_s3_bucket_logging_enable = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "00fdb18c-1645-4f90-a04e-3d49e4250ddd",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "02d2ec55-e6ef-45c4-8232-17799cba2fd7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "2bd4e095-9ede-4754-8543-fa168a41c858",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "508e44f6-eb9f-411f-b5dd-e7a7aaf62d38",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "cdf733f9-52d4-4f2f-8d7a-cc52b04246cb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "ff56719f-6194-4f5d-8ed3-f0cad34278e7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q4_log_metric_filter_for_without_mfa_signin_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_without_mfa_signin_changes",
      CreatedAt: "2023-04-25 12:23:42",
      FindingId: "0a8eca47-77c0-44ed-aaf6-02e7ac53b229",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm console logins that aren't protected by MFA is present. Monitoring for single-factor console logins increases visibility into accounts that aren't protected by MFA.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_cloud_trail_cloud_watch_log_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_cloud_watch_log_enabled",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "d0e50bfc-2043-46fd-9223-c9dae32254e8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This checks detects whether CloudTrail trails are configured to send logs to CloudWatch Logs",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_cloud_watch_log_enabled",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "d54d8e01-8cd0-42f9-b9eb-381933c518a6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This checks detects whether CloudTrail trails are configured to send logs to CloudWatch Logs",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_broker_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_log_metric_filter_for_s3_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_s3_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "4a2fef44-f4f0-4479-93c7-97e22b298deb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to S3 bucket policies is present. Monitoring these changes might reduce time to detect and correct permissive policies on sensitive S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_log_metric_filter_for_console_authentication_failure =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [
      {
        AccountNumber: "181570489212",
        CheckId: "log_metric_filter_for_console_authentication_failure",
        CreatedAt: "2023-04-25 12:23:43",
        FindingId: "3f6bfe2f-bb62-4315-b19b-811e50d2fae5",
        Metadata: {
          TaskRefId: null,
        },
        PillarId: "security",
        QuestionId: "detect-investigate-events",
        Recommendation:
          "This rule checks whether a metric filter and alarm for failed console authentication attempts is present",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "181570489212",
        ResourceType: "LogMetricFilter",
        Severity: "Low",
        Status: "Failed",
      },
    ],
    TotalRecords: 1,
  };
export const Security_Q4_vpc_route_resolver_query_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_route_resolver_query_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "01f75e08-8ff2-4982-95ed-bbf2d3e0d796",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Configuration to enable logging the DNS queries that originate in an Amazon VPC using the Route53 Resolver Query Logging feature. Query logs can be sent to CloudWatch logs, S3 Buckets, or Kinesis Data Firehose",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0ead93409c28ef71f",
      ResourceType: "Vpc",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_route_resolver_query_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "953c8023-c33a-463c-a4f6-8a43c13de3f5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Configuration to enable logging the DNS queries that originate in an Amazon VPC using the Route53 Resolver Query Logging feature. Query logs can be sent to CloudWatch logs, S3 Buckets, or Kinesis Data Firehose",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d2474fa5d3855b82",
      ResourceType: "Vpc",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_route_resolver_query_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "97def710-1c61-4317-91b4-a6d13885e7ac",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Configuration to enable logging the DNS queries that originate in an Amazon VPC using the Route53 Resolver Query Logging feature. Query logs can be sent to CloudWatch logs, S3 Buckets, or Kinesis Data Firehose",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0bdc428505f6126ff",
      ResourceType: "Vpc",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_route_resolver_query_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "9d1f1b88-bbaf-4efc-b555-6bfa733c9abd",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Configuration to enable logging the DNS queries that originate in an Amazon VPC using the Route53 Resolver Query Logging feature. Query logs can be sent to CloudWatch logs, S3 Buckets, or Kinesis Data Firehose",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d8fcaa7ed8e6b2a1",
      ResourceType: "Vpc",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q4_eks_cluster_control_plane_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_documentdb_cluster_delete_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_log_metric_filter_for_aws_cloud_trail_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_aws_cloud_trail_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "77b880a3-d7d9-4c87-9806-65542544e506",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to CloudTrail configuration settings is present. Monitoring these changes helps ensure sustained visibility to activities in the accoun",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_api_gateway_access_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_access_logging_check",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "95c92860-af97-4fe7-8ecc-480dff130cc4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that CloudWatch logging is enabled for all your Amazon API Gateway APIs in order to track and analyze execution behavior at the API stage level.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "2edfnla881",
      ResourceType: "APIGatewayStage",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_access_logging_check",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "b8df9da1-efb5-48d4-82f4-aecdfe4b38dd",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that CloudWatch logging is enabled for all your Amazon API Gateway APIs in order to track and analyze execution behavior at the API stage level.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "2edfnla881",
      ResourceType: "APIGatewayStage",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_api_gateway_stage_metrics_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_stage_metrics_enabled_check",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "66e52e68-6038-4bc2-9d3f-566733b1993b",
      Metadata: {
        TaskRefId: "2887f60d-2e59-4b03-918e-ab320dd9da0f",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Monitor API execution by using CloudWatch, which collects and processes raw data from API Gateway into readable, near-real-time metrics. These statistics are recorded for a period of 15 months so you can access historical information and gain a better perspective on how your web application or service is performing.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_stage_metrics_enabled_check",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "e4520380-cbc7-43ed-9790-71553e45a096",
      Metadata: {
        TaskRefId: "2887f60d-2e59-4b03-918e-ab320dd9da0f",
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Monitor API execution by using CloudWatch, which collects and processes raw data from API Gateway into readable, near-real-time metrics. These statistics are recorded for a period of 15 months so you can access historical information and gain a better perspective on how your web application or service is performing.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q4_compromise_appstream_user_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_ecs_cluster_registration_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q4_log_metric_filter_for_root_account_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_root_account_changes",
      CreatedAt: "2023-04-25 12:23:42",
      FindingId: "fd6d188d-6e2c-476e-b76f-28969942407b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for root user login attempts is present. Monitoring for root user logins provides visibility into the use of a fully privileged account and an opportunity to reduce the use of it.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_log_metric_filter_for_nacl_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_nacl_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "87662eea-28cc-4cc9-8963-d0c50c1ce751",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to NACLs is present. Monitoring these changes helps ensure that AWS resources and services aren't unintentionally exposed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q4_cloudtrail_mfa_delete_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloudtrail_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "096740c6-8dab-4267-9c21-69cd7d0623b0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your AWS CloudTrail logging bucket use Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of any versioned log files.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloudtrail_mfa_delete_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "d07ed5d0-0c70-43f0-8e4d-c08fe4104e52",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "detect-investigate-events",
      Recommendation:
        "Ensure that your AWS CloudTrail logging bucket use Multi-Factor Authentication (MFA) Delete feature in order to prevent the deletion of any versioned log files.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Security_Q6_Check_Details = [
  {
    CheckId: "security_group_restrict_outbound_traffic_check",
    Description:
      "Restrict outbound traffic to that which is necessary, and specifically deny all other traffic",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_version_enable",
    Description: "S3 bucket must have versioning enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "image_public_check",
    Description: "AMIs must not be publicly shared",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "notebook_instance_in_vpc_check",
    Description: "Amazon SageMaker notebook instance is placed in VPC",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elbv2_tls12_listener_policy_check",
    Description: "Do secure listeners enforce TLS 1.2",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "waf_regional_acls_logging_check",
    Description:
      "Ensure logging is enabled for Regional Resources(ALB, API gateway, AppSync) WAF Web Access Control Lists (Web ACLs)",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_instance_deletion_protection_check",
    Description: "RDS Instances deletion protection must be enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloudfront_cdn_logging_service_check",
    Description: "AWS CloudFront distribution with access logging is enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "documentdb_cluster_snapshot_public_share_check",
    Description: "DocumentDB public snapshots",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_inbound_remote_server_ports_check",
    Description:
      "No security groups allow ingress from 0.0.0.0/0 to remote server administration ports",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "default_security_group_restricts_all_traffic_check",
    Description:
      "Ensure default security groups restrict all inbound and oubound traffic",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloudfront_cdn_service_geo_info_check",
    Description:
      "AWS CloudFront web distribution with geo restriction is enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elb_internet_facing_secure_listeners_check",
    Description: "Ensure elastic load balancers are using secure listeners",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "redshift_cluster_public_access_check",
    Description: "Redshift Cluster Publicly Accessible",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "notebook_instance_direct_internet_access_check",
    Description:
      "Ensure that SageMaker Notebook does not have direct internet access",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_static_website_hosting_check",
    Description: "Static website hosting is disabled on S3 buckets",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "api_gateway_private_check",
    Description:
      "Ensure that the API Endpoint type in API Gateway is set to Private and is not exposed to the public internet",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "security_group_rdp_port_open_to_internet",
    Description: "Security Group RDP Port must be restricted",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloudfront_cdn_service_check",
    Description: "CloudFront In Use",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ec2_imdsv2_check",
    Description: "EC2 IMDSv2 enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "security_group_all_open_check",
    Description: "Ensure security groups restrict all inbound public traffic",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ecs_cluster_with_unconnected_agents_check",
    Description:
      "ECS Cluster should not have running container instances with unconnected agents",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "vpc_flow_log_enabled_check",
    Description: "Ensure VPC flow logging is enabled in all VPCs",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "qldb_deletion_protection_check",
    Description:
      "Ensure that QLDB ledger have deletion protection to protect from accidental deletion.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_public_access_check",
    Description: "RDS instances should not be publicly accessible",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloudfront_waf_intergration_check",
    Description: "CloudFront Integrated With WAF",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_are_not_public",
    Description: "S3 Block Public Access setting must be enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ec2_instance_SSM_successful_association_check",
    Description: "Does the instance have a successful SSM association",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "emr_cluster_termination_protection_check",
    Description: "EMR cluster termination protection enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "appstream_public_images",
    Description:
      "Ensure Appstream is images are not public, public images can expose your private data",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "subnet_public_ip_assignment_check",
    Description:
      "AWS VPC subnets  automatic public IP assignment must be disabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "waf_global_acls_logging_check",
    Description:
      "Ensure logging is enabled for Global (Cloudfront) WAF Web Access Control Lists (Web ACLs)",
    ErrorMessages:
      "[{'AccountNumber': '181570489212', 'Message': 'An error occurred (WAFInvalidParameterException) when calling the ListWebACLs operation: Error reason: The scope is not valid., field: SCOPE_VALUE, parameter: CLOUDFRONT', 'RegionCode': 'global', 'ResourceName': '181570489212'}]",
    Status: "ERROR",
  },
];

export const Security_Q7_Check_Details = [
  {
    CheckId: "api_gateway_key_method_request_check",
    Description: "Ensure that an API Key is required on a Method Request",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "aws_certificate_describe_check",
    Description: "AWS ACM Invalid or failed certificates",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloudfront_security_check",
    Description: "CloudFront Security Policy",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "aws_certificate_usage_check",
    Description: "AWS ACM has no unused certificates",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_lifecycle_check",
    Description: "S3 bucket lifecycle enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "aws_certificate_wildcard_check",
    Description: "AWS ACM Certificates with Wildcard Domain Names",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "are_any_server_certificates_stored_by_iam",
    Description:
      "There should not be any server certificates stored in AWS IAM, For certificates in a Region supported by AWS Certificate Manager (ACM), we recommend that you use ACM to provision, manage, and deploy your server certificates. In unsupported Regions, you mu",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elb_internet_facing_secure_listeners_check",
    Description: "Ensure elastic load balancers are using secure listeners",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Security_Q5_Check_Details = [
  {
    CheckId: "shield_advanced_elb_protection_check",
    Description:
      "Ensure that ELBv2s are protected by Shield Advanced,  AWS Shield Advanced provides additional protections against more sophisticated and larger attacks for your applications running on Elastic Load Balancing (ELB)",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_the_stage_protected_by_a_waf_wacl",
    Description:
      "Ensure that API Gateway is integrated with AWS WAF to get protection from web attacks",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "shield_advanced_drt_s3_bucket_check",
    Description:
      "You can grant permission to the Shield Response Team (SRT) to act on your behalf, accessing your AWS WAF logs and making calls to the AWS Shield Advanced and AWS WAF APIs to manage protections. With API access, SRT engineers can directly manage AWS WAF ru",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "appmesh_mesh_egress_check",
    Description: "App Mesh egress filter DROP_ALL",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_elasticsearch_check",
    Description: "Elasticsearch (tcp9200) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elbv2_drop_invalid_header_check",
    Description: "ELBv2 invalid HTTP headers dropped",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ec2_with_elastic_public_ip_check",
    Description:
      "EC2 Instances must not be associated with  Elastic or Public IP Address",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "security_group_open_smb_check",
    Description: "SMB (tcp445) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "emr_public_sg_block_config_in_region",
    Description:
      "This rule checks EMR public SG block configured for the Account in the region",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_dcom_rpc_check",
    Description: "WSDCOM-RPC (tcp135) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_the_endpoint_healthy",
    Description:
      "Ensure Global Accelerator endpoints such as load balancers, tcp servers etc are healthy",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_mysql_mariadb_check",
    Description: "MySQL/MariaDB (tcp3306) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_documentdb_check",
    Description: "DocDB (tcp27017) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "dms_replication_instance_public_access_check",
    Description:
      "Database Migration Service instances should not be publicly accessible",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "redshift_cluster_enhanced_vpc_routing_check",
    Description:
      "When you use Amazon Redshift enhanced VPC routing, Amazon Redshift forces all COPY and UNLOAD traffic between your cluster and your data repositories through your virtual private cloud (VPC) based on the Amazon VPC service. By using enhanced VPC routing, ",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "flow_logs_enabled_check",
    Description: "Accelerator should have flow logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "shield_advanced_elb_v2_protection_check",
    Description:
      "Ensure that ELBv2s are protected by Shield Advanced,  AWS Shield Advanced provides additional protections against more sophisticated and larger attacks for your applications running on Elastic Load Balancing (ELB)",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "security_group_open_memcached_check",
    Description: "Memcached (udp11211) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_cassandra_check",
    Description: "Cassandra (tcp9142) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_redis_check",
    Description: "Redis (tcp6379) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "shield_advanced_subscription_autorenew_check",
    Description: "AWS Shield Advanced Subscription on auto renew",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "workspaces_directory_default_internet_check",
    Description:
      "This rule checks whether Directory has default internet access enabled.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_oracle_check",
    Description: "OracleDB (tcp1521) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "guard_duty_enable_check",
    Description: "Amazon GuardDuty service is enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "shield_advanced_cloudfront_protection_check",
    Description:
      "You can grant permission to the Shield Response Team (SRT) to act on your behalf, accessing your AWS WAF logs and making calls to the AWS Shield Advanced and AWS WAF APIs to manage protections. With API access, SRT engineers can directly manage AWS WAF ru",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "shield_advanced_eip_protection_check",
    Description: "Elastic Ips  protected by Shield Advanced",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "lambda_function_vpc_check",
    Description: "Lambda functions should be in a VPC",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "broker_public_access_check",
    Description: "Ensure AWS MQ is not publicly accessible",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_telnet_check",
    Description: "TelNet (tcp23) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elb_deletion_protection_check",
    Description: "Enable ELBv2 Elastic Load Balancing Deletion Protection",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "security_group_open_elasticsearch2_check",
    Description: "Elasticsearch (tcp9300) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_splunkd_check",
    Description: "Splunkd (tcp8089) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "shield_advanced_route_53_protection_check",
    Description:
      "Ensure Route 53 hosted zones are protected by Shield Advanced,  AWS Shield Advanced provides additional protections against more sophisticated and larger attacks for your applications running on Route 53.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_redshift_check",
    Description: "Redshift (tcp5439) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_postgresql_check",
    Description: "PostgreSQL (tcp5432) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "vpc_default_check",
    Description: "Default VPC In Use",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "security_group_open_kafka_check",
    Description: "Kafka (tcp9092) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_mssql_check",
    Description: "MSSQL (tcp1433) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "eks_api_server_publicly_accessible_check",
    Description: "EKS API Server publicly accessible",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_open_kibana_check",
    Description: "Kibana (tcp5601) open to the internet",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

const Security_Q5_shield_advanced_elb_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_is_the_stage_protected_by_a_waf_wacl = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_the_stage_protected_by_a_waf_wacl",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "40ef9037-8869-4c1a-95d2-96d7f79fdef4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that API Gateway is integrated with AWS WAF to get protection from web attacks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "is_the_stage_protected_by_a_waf_wacl",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "5a999f6f-54c0-4c65-8a37-080a5a476457",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that API Gateway is integrated with AWS WAF to get protection from web attacks",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
const Security_Q5_shield_advanced_drt_s3_bucket_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "shield_advanced_drt_s3_bucket_check",
      CreatedAt: "2023-04-25 12:24:49",
      FindingId: "107f81f9-a89f-4a8f-ab2c-8e92e223f0e8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "You can grant permission to the Shield Response Team (SRT) to act on your behalf, accessing your AWS WAF logs and making calls to the AWS Shield Advanced and AWS WAF APIs to manage protections. With API access, SRT engineers can directly manage AWS WAF rules used mitigate application-layer DDoS attacks. Additionally, you can grant the SRT access to other data that you have stored in Amazon S3 buckets, such as packet captures or logs from an Application Load Balancer, Amazon CloudFront, or from third party sources.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "ShieldS3LogBuckets",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_appmesh_mesh_egress_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_elasticsearch_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_elbv2_drop_invalid_header_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elbv2_drop_invalid_header_check",
      CreatedAt: "2023-04-25 12:23:36",
      FindingId: "39d6b1b1-f099-4ef5-b9a8-341983782eb9",
      Metadata: {
        TaskRefId: "679ba019-c637-4d92-9696-8d97ba0f8689",
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that Drop Invalid Header Fields feature is enabled for your Amazon ELBV2 in order to follow security best practices and meet compliance requirements. If Drop Invalid Header Fields security feature is enabled, HTTP headers with header fields that are not valid are removed by the ELBv2 instead of being routed to the associated targets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb",
      ResourceType: "LoadBalancer",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_ec2_with_elastic_public_ip_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_with_elastic_public_ip_check",
      CreatedAt: "2023-04-25 12:24:07",
      FindingId: "30446846-b15c-40b7-b335-126d188ce120",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "It is a best practice to ensure EC2 instances are not associated with Elastic or Public IP addresses unless there is a business justification. This check verifies if EC2 instances in your AWS accounts have an Elastic or Public IP Address associated with them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-04b1c4e4f9284d09a",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_with_elastic_public_ip_check",
      CreatedAt: "2023-04-25 12:24:07",
      FindingId: "8d727399-2461-48dc-984f-8c3611094a65",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "It is a best practice to ensure EC2 instances are not associated with Elastic or Public IP addresses unless there is a business justification. This check verifies if EC2 instances in your AWS accounts have an Elastic or Public IP Address associated with them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0e72da0097f2af649",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_with_elastic_public_ip_check",
      CreatedAt: "2023-04-25 12:24:07",
      FindingId: "fbbffbc2-9c2e-4ef6-aa46-fbaa26e5767c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "It is a best practice to ensure EC2 instances are not associated with Elastic or Public IP addresses unless there is a business justification. This check verifies if EC2 instances in your AWS accounts have an Elastic or Public IP Address associated with them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0eb9f9cc0b178be09",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 3,
};
const Security_Q5_security_group_open_smb_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_emr_public_sg_block_config_in_region = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "emr_public_sg_block_config_in_region",
      CreatedAt: "2023-04-25 12:24:53",
      FindingId: "a07930e9-be28-49aa-9665-0d0eddf2509e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "This rule checks EMR public SG block configured for the Account in the region",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "EmrCluster",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_security_group_open_dcom_rpc_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_is_the_endpoint_healthy = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_mysql_mariadb_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_documentdb_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_dms_replication_instance_public_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_redshift_cluster_enhanced_vpc_routing_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_flow_logs_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_shield_advanced_elb_v2_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "shield_advanced_elb_v2_protection_check",
      CreatedAt: "2023-04-25 12:23:36",
      FindingId: "91652491-d9c9-4a24-99f0-2e1606b004ba",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that ELBv2s are protected by Shield Advanced,  AWS Shield Advanced provides additional protections against more sophisticated and larger attacks for your applications running on Elastic Load Balancing (ELB)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb",
      ResourceType: "LoadBalancer",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_security_group_open_memcached_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_cassandra_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_redis_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_shield_advanced_subscription_autorenew_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "shield_advanced_subscription_autorenew_check",
      CreatedAt: "2023-04-25 12:24:55",
      FindingId: "631d1fd5-aced-4a7d-a464-b406deda7b86",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure AWS Shield Advanced Subscription set to auto renew",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "Shield",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_workspaces_directory_default_internet_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_oracle_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_guard_duty_enable_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "guard_duty_enable_check",
      CreatedAt: "2023-04-25 12:24:56",
      FindingId: "b1c46a6d-881f-4b47-9cc8-f97e3e8aae1a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that Amazon GuardDuty service is currently enabled in the region in order to protect your AWS environment and infrastructure (AWS accounts and resources, IAM credentials, guest operating systems, applications, etc) against security threats. AWS GuardDuty is a managed threat detection service that continuously monitors your VPC flow logs, AWS CloudTrail event logs and DNS logs for malicious or unauthorized behavior.",
      RegionCode: "Region",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "GuardDuty",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_shield_advanced_cloudfront_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_shield_advanced_eip_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "shield_advanced_eip_protection_check",
      CreatedAt: "2023-04-25 12:24:45",
      FindingId: "25d41c4e-da02-4484-8406-4181d11cb707",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Use Amazon Shield Advanced to protect your AWS-powered web applications from Distributed Denial of Service (DDoS) attacks that can affect the application's availability and response time by overwhelming (flooding) them with traffic from multiple sources.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "eipalloc-0387c491883147520",
      ResourceType: "ElasticIp",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "shield_advanced_eip_protection_check",
      CreatedAt: "2023-04-25 12:24:45",
      FindingId: "b920b430-8c2a-4c73-b2b1-c7f5e0b62aef",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Use Amazon Shield Advanced to protect your AWS-powered web applications from Distributed Denial of Service (DDoS) attacks that can affect the application's availability and response time by overwhelming (flooding) them with traffic from multiple sources.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "eipalloc-0ae7b9a07f7f8b71e",
      ResourceType: "ElasticIp",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
const Security_Q5_lambda_function_vpc_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_vpc_check",
      CreatedAt: "2023-04-25 12:24:23",
      FindingId: "1ac894e6-9b0a-4445-93f7-65ad8a40e258",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "By default, Lambda runs functions in a secure VPC with access to AWS services and the internet. Lambda owns this VPC, which isn't connected to the account's default VPC. Internet access from a private subnet requires Network Address Translation (NAT).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_vpc_check",
      CreatedAt: "2023-04-25 12:24:23",
      FindingId: "55893ea5-d61f-44bc-840c-b1b2c8431395",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "By default, Lambda runs functions in a secure VPC with access to AWS services and the internet. Lambda owns this VPC, which isn't connected to the account's default VPC. Internet access from a private subnet requires Network Address Translation (NAT).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_vpc_check",
      CreatedAt: "2023-04-25 12:24:23",
      FindingId: "5d98189e-af1c-4641-9dea-3aab1774a245",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "By default, Lambda runs functions in a secure VPC with access to AWS services and the internet. Lambda owns this VPC, which isn't connected to the account's default VPC. Internet access from a private subnet requires Network Address Translation (NAT).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_vpc_check",
      CreatedAt: "2023-04-25 12:24:23",
      FindingId: "8c4e7d0c-a048-480b-8786-d01047950531",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "By default, Lambda runs functions in a secure VPC with access to AWS services and the internet. Lambda owns this VPC, which isn't connected to the account's default VPC. Internet access from a private subnet requires Network Address Translation (NAT).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_vpc_check",
      CreatedAt: "2023-04-25 12:24:23",
      FindingId: "aab6cb9e-38b5-4da2-abd7-862fb4dc8aca",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "By default, Lambda runs functions in a secure VPC with access to AWS services and the internet. Lambda owns this VPC, which isn't connected to the account's default VPC. Internet access from a private subnet requires Network Address Translation (NAT).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_function_vpc_check",
      CreatedAt: "2023-04-25 12:24:23",
      FindingId: "e1ecb4ea-4bbc-4ac4-9175-63427c5a859a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "By default, Lambda runs functions in a secure VPC with access to AWS services and the internet. Lambda owns this VPC, which isn't connected to the account's default VPC. Internet access from a private subnet requires Network Address Translation (NAT).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};
const Security_Q5_broker_public_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_telnet_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_elb_deletion_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elb_deletion_protection_check",
      CreatedAt: "2023-04-25 12:23:37",
      FindingId: "8da434d2-07d2-45f8-992c-0bee73431c84",
      Metadata: {
        TaskRefId: "d58092f3-3384-5727-a413-0bbcdad08ae5",
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure ELBv2 Load Balancers have Deletion Protection feature enabled in order to protect them from being accidentally deleted",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb",
      ResourceType: "LoadBalancer",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
const Security_Q5_security_group_open_elasticsearch2_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_splunkd_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_shield_advanced_route_53_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_redshift_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_postgresql_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_vpc_default_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_default_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "adf0ab3f-8b3f-4c58-90e2-44834071df31",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that your AWS application is not deployed within the default Virtual Private Cloud in order to follow security best practices. A default Virtual Private Cloud is a logically isolated virtual network created automatically for your AWS account the first time you provision Amazon EC2 resources. A default VPC is suitable for getting started quickly, however, when you deploy complex applications and use multi-tier architectures you may need to keep parts of your network private or customize the network model, therefore it is recommended to create a non-default VPC that suits your specific requirements.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d2474fa5d3855b82",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_default_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "0571b515-a942-412b-9e56-a5d2930356d5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that your AWS application is not deployed within the default Virtual Private Cloud in order to follow security best practices. A default Virtual Private Cloud is a logically isolated virtual network created automatically for your AWS account the first time you provision Amazon EC2 resources. A default VPC is suitable for getting started quickly, however, when you deploy complex applications and use multi-tier architectures you may need to keep parts of your network private or customize the network model, therefore it is recommended to create a non-default VPC that suits your specific requirements.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0ead93409c28ef71f",
      ResourceType: "Vpc",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_default_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "28702184-6bf9-40c8-b121-b644c0b3d280",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that your AWS application is not deployed within the default Virtual Private Cloud in order to follow security best practices. A default Virtual Private Cloud is a logically isolated virtual network created automatically for your AWS account the first time you provision Amazon EC2 resources. A default VPC is suitable for getting started quickly, however, when you deploy complex applications and use multi-tier architectures you may need to keep parts of your network private or customize the network model, therefore it is recommended to create a non-default VPC that suits your specific requirements.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0bdc428505f6126ff",
      ResourceType: "Vpc",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_default_check",
      CreatedAt: "2023-04-25 12:25:09",
      FindingId: "beefed14-69fa-41ad-92df-1b4d729d353e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "network-protection",
      Recommendation:
        "Ensure that your AWS application is not deployed within the default Virtual Private Cloud in order to follow security best practices. A default Virtual Private Cloud is a logically isolated virtual network created automatically for your AWS account the first time you provision Amazon EC2 resources. A default VPC is suitable for getting started quickly, however, when you deploy complex applications and use multi-tier architectures you may need to keep parts of your network private or customize the network model, therefore it is recommended to create a non-default VPC that suits your specific requirements.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d8fcaa7ed8e6b2a1",
      ResourceType: "Vpc",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
const Security_Q5_security_group_open_kafka_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_mssql_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_eks_api_server_publicly_accessible_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
const Security_Q5_security_group_open_kibana_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

const Security_Q7_aws_certificate_describe_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

const Security_Q7_cloudfront_security_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

const Security_Q7_aws_certificate_usage_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

const Security_Q7_s3_bucket_lifecycle_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_lifecycle_check",
      CreatedAt: "2023-04-25 12:23:46",
      FindingId: "4032a5fc-9c61-4a2f-8fe4-b390c8c24abe",
      Metadata: {
        TaskRefId: "e7eba206-8f26-40a2-833e-3709ec2be985",
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "Amazon S3 buckets using lifecycle configurations improve security and help optimize costs. An S3 lifecycle configuration is a set of one or more rules, where each rule defines an action (transition or expiration action) for Amazon S3 to apply to a group of objects. A lifecycle configuration is used to manage Amazon S3 data during its lifetime. This check verifies if your S3 buckets have lifecycle policies enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_lifecycle_check",
      CreatedAt: "2023-04-25 12:23:46",
      FindingId: "7450a782-e2f5-4b43-9c19-17e008403bc1",
      Metadata: {
        TaskRefId: "e7eba206-8f26-40a2-833e-3709ec2be985",
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "Amazon S3 buckets using lifecycle configurations improve security and help optimize costs. An S3 lifecycle configuration is a set of one or more rules, where each rule defines an action (transition or expiration action) for Amazon S3 to apply to a group of objects. A lifecycle configuration is used to manage Amazon S3 data during its lifetime. This check verifies if your S3 buckets have lifecycle policies enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_lifecycle_check",
      CreatedAt: "2023-04-25 12:23:46",
      FindingId: "aaedb615-4197-406b-83f7-00e9147dedc2",
      Metadata: {
        TaskRefId: "e7eba206-8f26-40a2-833e-3709ec2be985",
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "Amazon S3 buckets using lifecycle configurations improve security and help optimize costs. An S3 lifecycle configuration is a set of one or more rules, where each rule defines an action (transition or expiration action) for Amazon S3 to apply to a group of objects. A lifecycle configuration is used to manage Amazon S3 data during its lifetime. This check verifies if your S3 buckets have lifecycle policies enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_lifecycle_check",
      CreatedAt: "2023-04-25 12:23:46",
      FindingId: "b986aa59-112f-4515-832a-49bc0f67da6e",
      Metadata: {
        TaskRefId: "e7eba206-8f26-40a2-833e-3709ec2be985",
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "Amazon S3 buckets using lifecycle configurations improve security and help optimize costs. An S3 lifecycle configuration is a set of one or more rules, where each rule defines an action (transition or expiration action) for Amazon S3 to apply to a group of objects. A lifecycle configuration is used to manage Amazon S3 data during its lifetime. This check verifies if your S3 buckets have lifecycle policies enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_lifecycle_check",
      CreatedAt: "2023-04-25 12:23:46",
      FindingId: "e6297fca-307c-4b68-b17f-65492fdf06ae",
      Metadata: {
        TaskRefId: "e7eba206-8f26-40a2-833e-3709ec2be985",
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "Amazon S3 buckets using lifecycle configurations improve security and help optimize costs. An S3 lifecycle configuration is a set of one or more rules, where each rule defines an action (transition or expiration action) for Amazon S3 to apply to a group of objects. A lifecycle configuration is used to manage Amazon S3 data during its lifetime. This check verifies if your S3 buckets have lifecycle policies enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_lifecycle_check",
      CreatedAt: "2023-04-25 12:23:46",
      FindingId: "2084fae0-ac9e-4e3a-9588-9606a16abfce",
      Metadata: {
        TaskRefId: "e7eba206-8f26-40a2-833e-3709ec2be985",
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "Amazon S3 buckets using lifecycle configurations improve security and help optimize costs. An S3 lifecycle configuration is a set of one or more rules, where each rule defines an action (transition or expiration action) for Amazon S3 to apply to a group of objects. A lifecycle configuration is used to manage Amazon S3 data during its lifetime. This check verifies if your S3 buckets have lifecycle policies enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};

const Security_Q7_aws_certificate_wildcard_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

const Security_Q7_are_any_server_certificates_stored_by_iam = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "are_any_server_certificates_stored_by_iam",
      CreatedAt: "2023-04-25 12:24:57",
      FindingId: "e821cdbd-44a1-4e4b-9d98-620035bb5f9b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "There should not be any server certificates stored in AWS IAM, For certificates in a Region supported by AWS Certificate Manager (ACM), we recommend that you use ACM to provision, manage, and deploy your server certificates. In unsupported Regions, you must use IAM as a certificate manager.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "181570489212/global",
      ResourceType: "ServerCerts",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};

const Security_Q7_elb_internet_facing_secure_listeners_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elb_internet_facing_secure_listeners_check",
      CreatedAt: "2023-04-25 12:23:36",
      FindingId: "9df72e44-b3f9-4ccf-b977-be11c62fc556",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "This control checks whether Load Balancer listeners are configured with HTTPS/TLS protocol connections",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb/HTTP",
      ResourceType: "LoadBalancer",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "elb_internet_facing_secure_listeners_check",
      CreatedAt: "2023-04-25 12:23:36",
      FindingId: "38779e80-0242-4569-b982-c8a2b125b31b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "This control checks whether Load Balancer listeners are configured with HTTPS/TLS protocol connections",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb/HTTP",
      ResourceType: "LoadBalancer",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};

export const Security_Q7_api_gateway_key_method_request_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_key_method_request_check",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "a963b07a-a438-449e-985c-5d42fb40e883",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "API keys are string tokens that you provide to client application developers to grant access to your APIs. You can use API keys together with usage plans or Lambda authorizers to control access to your APIs",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "2edfnla881",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_key_method_request_check",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "c116d0d0-c5b9-4757-a9fc-7af0c9d177a1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "data-classification",
      Recommendation:
        "API keys are string tokens that you provide to client application developers to grant access to your APIs. You can use API keys together with usage plans or Lambda authorizers to control access to your APIs",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "2edfnla881",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Security_Q6_security_group_restrict_outbound_traffic_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "17f99799-581e-4dc9-b86f-c951ebe2233a",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-0344a99f2eb9135f2",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "1aa29c24-4954-40cc-90a1-03a1652e967d",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-0e4dc6de178b855a0",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "2b642eb0-80bb-49d3-8c9a-32038ec5376e",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-09d089b8e9938d9e0",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "3a85fb97-09ad-49e0-9e05-dad9c2cb9752",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-063fc5265799cc140",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "5d323487-c814-4e84-ac67-bbc54f3215eb",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-0b1eeca42f8181b58",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "7489aa50-d9e2-451b-8b5a-e304742c41c0",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-04ac3ddd2255407e3",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "a02eefb8-0b5f-4046-8421-b5d57502acd3",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-0ab1a85e19843d7cf",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "b9038309-8e5b-4255-8ea8-067412684790",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-095358f4cdcc3b15d",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_restrict_outbound_traffic_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "f917d0e6-f7ea-4577-b999-24725830b6d0",
      Metadata: {
        TaskRefId: "476ff272-191e-41d6-a9d4-a795f403f769",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that no security group allows unrestricted egress access, this check looks for security group with ALL outbound traffic open to public.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-063466d0b4e1fbf57",
      ResourceType: "SecurityGroup",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 9,
};
export const Security_Q6_s3_bucket_version_enable = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "025ba609-a06f-4e0f-abbb-a9f08feb7501",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "1126257c-a3dc-4016-af6f-08e497710718",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "673e9795-fd45-4cfd-b8b2-5a4edc37ec48",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "c538f418-a23c-4fe2-a497-5f33d92e7300",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "cfea6e2f-d2b3-43c1-9e62-47298f3cd830",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "f20bc703-6c6e-429f-aceb-42346420f1f4",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q6_image_public_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "image_public_check",
      CreatedAt: "2023-04-25 12:24:41",
      FindingId: "ebf26e59-1dca-49e7-96ae-dda315b9576f",
      Metadata: {
        TaskRefId: "7da0957c-5be0-4482-a082-f0c62fd3e35b",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "To avoid exposing sensitive data, ensure that your AWS AMIs are not publicly shared with the other AWS accounts. It is a best practice to avoid sharing your AMIs with all AWS accounts. If required, you can share your images with specific AWS accounts without making them public. This check verifies if your images are publicly accessible.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "ami-092c18574fce16603",
      ResourceType: "Image",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "image_public_check",
      CreatedAt: "2023-04-25 12:24:41",
      FindingId: "088e97c2-76ec-43cd-8aff-d0a663d7f7c8",
      Metadata: {
        TaskRefId: "7da0957c-5be0-4482-a082-f0c62fd3e35b",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "To avoid exposing sensitive data, ensure that your AWS AMIs are not publicly shared with the other AWS accounts. It is a best practice to avoid sharing your AMIs with all AWS accounts. If required, you can share your images with specific AWS accounts without making them public. This check verifies if your images are publicly accessible.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "ami-0a8d4563854aec173",
      ResourceType: "Image",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q6_notebook_instance_in_vpc_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_elbv2_tls12_listener_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elbv2_tls12_listener_policy_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "7b2dc33c-eeb0-4af8-8c0c-1e9cbe3afdc8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation: "",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb",
      ResourceType: "LoadBalancer",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q6_waf_regional_acls_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_rds_instance_deletion_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_deletion_protection_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "04ba643d-2c4c-4ce0-953c-00d7782d8f83",
      Metadata: {
        TaskRefId: "03e37aff-1dfc-4090-b88a-558cf2671655",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "To protect RDS instances from accidental deletion you must ensure 'Deletion Protection feature' is enabled. This check verifies if the 'Deletion Protection feature' is enabled for all RDS instances in your AWS Account.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_deletion_protection_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "9e1065aa-237a-4586-a6c8-8053832f097f",
      Metadata: {
        TaskRefId: "03e37aff-1dfc-4090-b88a-558cf2671655",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "To protect RDS instances from accidental deletion you must ensure 'Deletion Protection feature' is enabled. This check verifies if the 'Deletion Protection feature' is enabled for all RDS instances in your AWS Account.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q6_cloudfront_cdn_logging_service_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_documentdb_cluster_snapshot_public_share_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_security_group_inbound_remote_server_ports_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_remote_server_ports_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "1cb77b86-a00b-402c-80b8-a0ea58181d37",
      Metadata: {
        TaskRefId: "5d166006-e931-444c-a144-80954bba0049",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that security groups do not allow unrestricted ingress access to port 3389 and 22. Removing unfettered connectivity to remote console services, such as SSH, reduces a server's exposure to risk.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-04ac3ddd2255407e3",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_remote_server_ports_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "14e8b3cf-bf89-4fe3-958c-5cdabc646e5e",
      Metadata: {
        TaskRefId: "5d166006-e931-444c-a144-80954bba0049",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "It is recommended that security groups do not allow unrestricted ingress access to port 3389 and 22. Removing unfettered connectivity to remote console services, such as SSH, reduces a server's exposure to risk.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-0b1eeca42f8181b58",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q6_default_security_group_restricts_all_traffic_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "default_security_group_restricts_all_traffic_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "05c19e23-c507-4c72-88e9-39d15aa6ab73",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Default security groups are checked using this control to identify whether there is any in-bound or outbound rule is present",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-063fc5265799cc140",
      ResourceType: "SecurityGroup",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "default_security_group_restricts_all_traffic_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "1916f295-e206-4fb8-8320-976977e60219",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Default security groups are checked using this control to identify whether there is any in-bound or outbound rule is present",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-09d089b8e9938d9e0",
      ResourceType: "SecurityGroup",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "default_security_group_restricts_all_traffic_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "307063ed-0f95-4f2e-bed9-83dfef6b509d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Default security groups are checked using this control to identify whether there is any in-bound or outbound rule is present",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0344a99f2eb9135f2",
      ResourceType: "SecurityGroup",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "default_security_group_restricts_all_traffic_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "da86cac2-f5f1-4c0f-a7ba-3728729b844b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Default security groups are checked using this control to identify whether there is any in-bound or outbound rule is present",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-095358f4cdcc3b15d",
      ResourceType: "SecurityGroup",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q6_cloudfront_cdn_service_geo_info_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_elb_internet_facing_secure_listeners_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elb_internet_facing_secure_listeners_check",
      CreatedAt: "2023-04-25 12:23:36",
      FindingId: "0dee0eaa-a348-4261-a33f-6ebca57bd294",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This control checks whether Load Balancer listeners are configured with HTTPS/TLS protocol connections",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb/HTTP",
      ResourceType: "LoadBalancer",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "elb_internet_facing_secure_listeners_check",
      CreatedAt: "2023-04-25 12:23:36",
      FindingId: "de75049b-74d6-4d8e-af9c-066ec4f0f945",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This control checks whether Load Balancer listeners are configured with HTTPS/TLS protocol connections",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb/HTTP",
      ResourceType: "LoadBalancer",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q6_redshift_cluster_public_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_notebook_instance_direct_internet_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_s3_static_website_hosting_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_static_website_hosting_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "660a173d-18df-40a8-8c3c-a7b559e59989",
      Metadata: {
        TaskRefId: "390c52bd-ed57-4ad2-b4c1-b3a48c6f8d97",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "A static website on a S3 bucket requires public read access to the bucket. To make bucket publicly readable, you must disable block public access settings for the bucket and write a bucket policy that grants public read access, it has potential risk of exposure when you turn off block public access settings to make your bucket public, anyone on the internet can access your bucket, it is strongly recommended to block public access.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_static_website_hosting_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "66230d8c-ba9b-41b7-94bd-9cceb79ac0dc",
      Metadata: {
        TaskRefId: "390c52bd-ed57-4ad2-b4c1-b3a48c6f8d97",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "A static website on a S3 bucket requires public read access to the bucket. To make bucket publicly readable, you must disable block public access settings for the bucket and write a bucket policy that grants public read access, it has potential risk of exposure when you turn off block public access settings to make your bucket public, anyone on the internet can access your bucket, it is strongly recommended to block public access.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_static_website_hosting_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "69d8a613-34bd-4903-90df-e53848fab0af",
      Metadata: {
        TaskRefId: "390c52bd-ed57-4ad2-b4c1-b3a48c6f8d97",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "A static website on a S3 bucket requires public read access to the bucket. To make bucket publicly readable, you must disable block public access settings for the bucket and write a bucket policy that grants public read access, it has potential risk of exposure when you turn off block public access settings to make your bucket public, anyone on the internet can access your bucket, it is strongly recommended to block public access.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_static_website_hosting_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "7bb64b3e-c5af-440e-83b6-77542979597e",
      Metadata: {
        TaskRefId: "390c52bd-ed57-4ad2-b4c1-b3a48c6f8d97",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "A static website on a S3 bucket requires public read access to the bucket. To make bucket publicly readable, you must disable block public access settings for the bucket and write a bucket policy that grants public read access, it has potential risk of exposure when you turn off block public access settings to make your bucket public, anyone on the internet can access your bucket, it is strongly recommended to block public access.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_static_website_hosting_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "f9ffa8d8-7ac2-490c-b1f6-f4956c3bc378",
      Metadata: {
        TaskRefId: "390c52bd-ed57-4ad2-b4c1-b3a48c6f8d97",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "A static website on a S3 bucket requires public read access to the bucket. To make bucket publicly readable, you must disable block public access settings for the bucket and write a bucket policy that grants public read access, it has potential risk of exposure when you turn off block public access settings to make your bucket public, anyone on the internet can access your bucket, it is strongly recommended to block public access.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_static_website_hosting_check",
      CreatedAt: "2023-04-25 12:23:59",
      FindingId: "fbeddc16-e6c9-443e-accb-28890edd71b9",
      Metadata: {
        TaskRefId: "390c52bd-ed57-4ad2-b4c1-b3a48c6f8d97",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "A static website on a S3 bucket requires public read access to the bucket. To make bucket publicly readable, you must disable block public access settings for the bucket and write a bucket policy that grants public read access, it has potential risk of exposure when you turn off block public access settings to make your bucket public, anyone on the internet can access your bucket, it is strongly recommended to block public access.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q6_api_gateway_private_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_private_check",
      CreatedAt: "2023-04-25 12:24:18",
      FindingId: "2f5b444f-90ba-4887-a95b-5af426f912bd",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This rule checks whether API Gateway if API Endpoint type in API Gateway is exposed to public",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "2edfnla881",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q6_security_group_rdp_port_open_to_internet = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_rdp_port_open_to_internet",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "75c25fe2-196b-4d57-a103-93b49c3133c9",
      Metadata: {
        TaskRefId: "7a8d320b-2741-403c-8247-3f5290018948",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Attackers use brute force techniques to gain access to EC2 instances. It is a best practice to implement least privileges. This check verifies if EC2 security groups allows unrestricted access to TCP port 3389.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "sg-04ac3ddd2255407e3",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q6_cloudfront_cdn_service_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloudfront_cdn_service_check",
      CreatedAt: "2023-04-25 12:24:39",
      FindingId: "eaa6327b-e6e0-43aa-98db-458bb640ac8d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure that AWS CloudFront Content Delivery Network (CDN) service is used within your AWS account to secure and accelerate the delivery of your websites, media files or static resources handled by your web applications.",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "CloudFront-Distribution",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q6_ec2_imdsv2_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_imdsv2_check",
      CreatedAt: "2023-04-25 12:24:09",
      FindingId: "ee395b7b-377d-4815-9499-e2f0bf0ce933",
      Metadata: {
        TaskRefId: "ddcbc886-4292-4948-abc4-4f599af5b5b4",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This rule checks whether IMDSv2 is enabled on all instances launched, IMDS provides data about your instance that you can use to configure or manage the running instance.Version 2 of the IMDS adds new protections that weren't available in IMDSv1 to further safeguard your EC2 instances.Amazon EC2",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "i-04b1c4e4f9284d09a",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q6_security_group_all_open_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_all_open_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "4708613e-897d-4f58-9763-84742d4ef9b3",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This check identifies security groups which allow all traffic from the internet, best practice is to exercise principle of least Privilege.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-063466d0b4e1fbf57",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_all_open_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "5681a07f-2c4f-48e9-824e-6db84f68cd4d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This check identifies security groups which allow all traffic from the internet, best practice is to exercise principle of least Privilege.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0ab1a85e19843d7cf",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_all_open_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "662c342b-d8af-4760-932e-2b9a0facce6d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This check identifies security groups which allow all traffic from the internet, best practice is to exercise principle of least Privilege.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-04ac3ddd2255407e3",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_all_open_check",
      CreatedAt: "2023-04-25 12:23:34",
      FindingId: "ff04905f-2934-43b1-bcbe-c727ccb3afb6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This check identifies security groups which allow all traffic from the internet, best practice is to exercise principle of least Privilege.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0e4dc6de178b855a0",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q6_ecs_cluster_with_unconnected_agents_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_vpc_flow_log_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "4d0a443a-99c6-438f-a5df-c84b98a221eb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d2474fa5d3855b82",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "bb600828-b45d-4076-a119-2022fda60a7f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d8fcaa7ed8e6b2a1",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "bdc9936d-487a-4936-80aa-9e5f729b5579",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0bdc428505f6126ff",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "f437cda0-e836-42ea-b02d-a927c9fc4fda",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0ead93409c28ef71f",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q6_qldb_deletion_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_rds_public_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_public_access_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "4eba8821-2d91-4509-a9f0-9f5c1b11c726",
      Metadata: {
        TaskRefId: "f5ee0663-6823-40ba-b59f-76c2349055fc",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "RDS instances that are publicly accessible pose unauthorized access and security risks.  This check verifies if your RDS databases are publicly hosted publicly accessible.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_public_access_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "b20fd0e7-b60d-4ee0-8957-534d19759a05",
      Metadata: {
        TaskRefId: "f5ee0663-6823-40ba-b59f-76c2349055fc",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "RDS instances that are publicly accessible pose unauthorized access and security risks.  This check verifies if your RDS databases are publicly hosted publicly accessible.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q6_cloudfront_waf_intergration_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_s3_bucket_are_not_public = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_are_not_public",
      CreatedAt: "2023-04-25 12:23:57",
      FindingId: "68ea9e9c-a105-4460-9508-8d6b31084d89",
      Metadata: {
        TaskRefId: "424b3782-2457-4301-b9f1-e676ad213564",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Amazon S3 public access block is designed to provide controls across an entire AWS account or at the individual S3 bucket level to ensure that objects are not publicly accessible.  Unless you intend to have your S3 buckets be publicly accessible, you should enable Amazon S3 Block Public Access configuration. This check verifies if the Block Public Access setting is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_are_not_public",
      CreatedAt: "2023-04-25 12:23:57",
      FindingId: "ecaaa53b-9583-475c-9a9d-a54f9631767c",
      Metadata: {
        TaskRefId: "424b3782-2457-4301-b9f1-e676ad213564",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Amazon S3 public access block is designed to provide controls across an entire AWS account or at the individual S3 bucket level to ensure that objects are not publicly accessible.  Unless you intend to have your S3 buckets be publicly accessible, you should enable Amazon S3 Block Public Access configuration. This check verifies if the Block Public Access setting is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_are_not_public",
      CreatedAt: "2023-04-25 12:23:57",
      FindingId: "042db642-bcb8-4243-ad21-69c2071e963b",
      Metadata: {
        TaskRefId: "424b3782-2457-4301-b9f1-e676ad213564",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Amazon S3 public access block is designed to provide controls across an entire AWS account or at the individual S3 bucket level to ensure that objects are not publicly accessible.  Unless you intend to have your S3 buckets be publicly accessible, you should enable Amazon S3 Block Public Access configuration. This check verifies if the Block Public Access setting is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_are_not_public",
      CreatedAt: "2023-04-25 12:23:57",
      FindingId: "3b576f9a-dcd3-4a4e-b7e6-e4a6fb0dc10f",
      Metadata: {
        TaskRefId: "424b3782-2457-4301-b9f1-e676ad213564",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Amazon S3 public access block is designed to provide controls across an entire AWS account or at the individual S3 bucket level to ensure that objects are not publicly accessible.  Unless you intend to have your S3 buckets be publicly accessible, you should enable Amazon S3 Block Public Access configuration. This check verifies if the Block Public Access setting is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_are_not_public",
      CreatedAt: "2023-04-25 12:23:57",
      FindingId: "7c7ff575-4a8a-45dc-85a8-b1e1f38d95ca",
      Metadata: {
        TaskRefId: "424b3782-2457-4301-b9f1-e676ad213564",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Amazon S3 public access block is designed to provide controls across an entire AWS account or at the individual S3 bucket level to ensure that objects are not publicly accessible.  Unless you intend to have your S3 buckets be publicly accessible, you should enable Amazon S3 Block Public Access configuration. This check verifies if the Block Public Access setting is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_are_not_public",
      CreatedAt: "2023-04-25 12:23:57",
      FindingId: "f89f3a7d-c137-489d-aaa6-99b714d53f40",
      Metadata: {
        TaskRefId: "424b3782-2457-4301-b9f1-e676ad213564",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Amazon S3 public access block is designed to provide controls across an entire AWS account or at the individual S3 bucket level to ensure that objects are not publicly accessible.  Unless you intend to have your S3 buckets be publicly accessible, you should enable Amazon S3 Block Public Access configuration. This check verifies if the Block Public Access setting is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q6_ec2_instance_SSM_successful_association_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_instance_SSM_successful_association_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "3abbffb6-37a7-4fdb-b197-92c9139779fd",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "EC2 Instances managed by Systems Manager should have a successful Association status",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0eb9f9cc0b178be09",
      ResourceType: "Instance",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_instance_SSM_successful_association_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "d259634a-981e-418c-88c0-236fe50eec7c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "EC2 Instances managed by Systems Manager should have a successful Association status",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0e72da0097f2af649",
      ResourceType: "Instance",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_instance_SSM_successful_association_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "ff1f761c-6358-4efc-a604-aa4a28d5035b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "EC2 Instances managed by Systems Manager should have a successful Association status",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-04b1c4e4f9284d09a",
      ResourceType: "Instance",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 3,
};
export const Security_Q6_emr_cluster_termination_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q6_appstream_public_images = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "001386d8-80b7-4e62-9262-5c8ec4c7465b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-WinServer2016-10-05-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "011c5cdf-ddb3-4b95-becd-85baf625b984",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-Design-WinServer2016-03-29-2023",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "0dbe5061-5d88-4189-9465-77a6d16fb0c5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/Amazon-AppStream2-Sample-Image-02-04-2019",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "27e6a412-f079-4a9b-a4e9-ef7bf139d2f5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-Pro-WinServer2012R2-09-01-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "37e0c2a7-2b3a-41cc-a2e2-3c1e05b5104c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-Design-WinServer2012R2-10-05-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "57d75fc9-fd2b-4da9-8580-2e1994a09e5e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-WinServer2012R2-07-12-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "5f76f7c3-b127-4ce5-82f4-361a0ff3f8ae",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-G4dn-WinServer2012R2-09-01-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "65995e2c-697f-45dc-8f6d-5769ca69cb8f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-G4dn-WinServer2012R2-03-29-2023",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "6a522d00-dd48-4bff-ad90-735d9c77da5a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-G4dn-WinServer2012R2-10-05-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "appstream_public_images",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "768ee835-375c-443b-add8-4be4f928d669",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Ensure Appstream is images are not public, public images can expose your private data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:appstream:us-east-1::image/AppStream-Graphics-Design-WinServer2016-10-05-2022",
      ResourceType: "AppStream",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 25,
};
export const Security_Q6_subnet_public_ip_assignment_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "461dd348-780f-40cf-be70-4d70c71df8de",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-08e89a498fbedd7b4",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:13",
      FindingId: "553cbd4e-5790-495b-a0a6-fb6fcfe05794",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-00c8617774f23a18e",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "8ba0554e-9b12-4cd3-8a95-e5959137ad8a",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-06210181a00080f2a",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "9e524d58-b3c2-409f-8e8e-5dbe1e2956b1",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-051b6ff8cd6f841da",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:13",
      FindingId: "b2de2019-86e0-4a62-a665-d0a73bf42644",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-02e2496f1e742a190",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:13",
      FindingId: "b8cb4054-64a4-4a84-ad65-eee7b82b57ee",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-009eb04643d0d1e93",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "b9a56c0a-0eec-41cf-86cc-2e76af0e547a",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-09ba50192c1baf3f8",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "bd48c5fe-33df-4cc0-948a-e01b0228c6cd",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-0c9f8fdcb1f55a86a",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "ea27f4e4-d2b3-420b-8dcb-837bfc514ee9",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-09a4a8a69138fbfef",
      ResourceType: "Subnet",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "subnet_public_ip_assignment_check",
      CreatedAt: "2023-04-25 12:25:14",
      FindingId: "084a530a-3227-4976-9750-b907a338a389",
      Metadata: {
        TaskRefId: "0d35ca25-585c-4e08-9450-a4d8dc81eca1",
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "Subnets with automatic Public IP assignment can inadvertently expose the instances within this subnet to the internet. It is recommended to disable this feature for subnets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "subnet-09fcbc890e1c3171d",
      ResourceType: "Subnet",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 12,
};
export const Security_Q6_waf_global_acls_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "waf_global_acls_logging_check",
      CreatedAt: "2023-04-25 12:24:18",
      FindingId: "5c36f93f-72ac-43b6-becc-4707e5d739a5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-compute",
      Recommendation:
        "To capture information about web traffic inspected by Web ACLs, logging on Web ACLs should be enabled which includes the time that Waf received the request from AWS resource, detailed info about the request, and the action for rule that each request matched. These logs are helpful to perform audit and retrospective analysis",
      RegionCode: "global",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "Waf",
      Severity: "Medium",
      Status: "Error",
    },
  ],
  TotalRecords: 1,
};

export const Security_Q8_Check_Details = [
  {
    CheckId: "notebook_instance_encrypted_check",
    Description:
      "SageMaker Notebook Instance Data Encryption should be enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elastic_search_at_rest_encryption_check",
    Description: "ElastiSearch At-Rest Encryption",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "notebook_instance_KMS_CMK_encryption_check",
    Description:
      "SageMaker Notebook Instance Data Encryption with KMS CMKs is enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "lambda_environment_variables_cmk_encryption_check",
    Description: "Lambda environment variables without CMK encryption enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ebs_volume_encryption_check",
    Description: "EBS volumes must be encrypted",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "S3_bucket_has_bucket_policy_check",
    Description: "S3 Bucket Policy not Configured",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "training_job_volume_encryption_check",
    Description:
      "SageMaker training jobs have volume encryption enabled with KMS",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "workspaces_root_volume_encryption_check",
    Description: "Is root volume encrypted",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "emr_security_config_config_ebs_encryption_check",
    Description: "EMR At-Rest Encryption",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_database_encryption_check",
    Description:
      "AWS RDS databases are encrypted using KMS Customer Managed Keys",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "workspaces_user_volume_encryption_check",
    Description: "WorkSpace user volume encrypted",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "glue_data_catalog_encryption_at_rest_check",
    Description: "Glue Data Catalog Encryption At Rest",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "are_plaintext_env_variables_used",
    Description:
      "Ensure CodeBuild plaintext environmental variables are not used",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_artifact_encryption_enabled",
    Description: "CodeBuild artifact encryption enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "emr_security_config_encryption_at_rest_check",
    Description:
      "EMR cluster security configs enforce encryption at rest for EMRFS",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "efs_file_system_encrypted",
    Description: "Ensure that your Amazon EFS file systems are encrypted",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_cache_encryption_enabled",
    Description: "Ensure that cache encryption enabled on API Gateway",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ebs_volume_encryption_check_account_level",
    Description: "Enable default encryption for new EBS volumes.",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kinesis_encryption_check",
    Description: "Kinesis Data Streams server-side encryption must be enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "crawler_cloudwatch_encryption_check",
    Description: "Is CWL encryption configured for the crawler.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "documentdb_cluster_aws_kms_cmk_encryption_check",
    Description: "DocumentDB Encrypted with AWS KMS CMKs",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "sqs_queue_sse_check",
    Description: "SQS Queue Server Side Encryption (SSE)",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "documentdb_cluster_snapshot_encryption_check",
    Description: "DocumentDB cluster snapshots encrypted",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "broker_kms_cmk_check",
    Description:
      "Amazon MQ Message brokers should be encrypted with customer-managed KMS CMKs",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ebs_snapshot_encryption_check",
    Description: "EBS snapshots must be encrypted",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "documentdb_instance_encrypted",
    Description:
      "Ensure that encryption is enabled for your AWS DocumentDB (with MongoDB compatibility) clusters for additional data security and in order to meet compliance requirements for data-at-rest encryption.",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "neptune_instance_at_rest_encryption_check",
    Description: "Neptune DB At-Rest Encryptions",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elasticache_redis_at_rest_encryption_check",
    Description: "ElastiCache Redis At-Rest Encryption",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "redshift_encryption_status_check",
    Description: "Redshift Cluster Encryption",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "encrypted_ami_check",
    Description: "AMIs encrypted",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kms_key_policy_public_check",
    Description: "KMS Keys Exposed",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "glue_security_configuration_job_bookmark_encryption_check",
    Description: "Glue Job Bookmark Encryption Mode",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "codebuild_s3_logging_encryption_check",
    Description:
      "CodeBuild projects should not have S3 log encryption disabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "sqs_resource_based_policy_check",
    Description: "SQS queue has a resource-based policy configured",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "sns_topic_sse_check",
    Description: "SNS Topic  Server Side Encryption (SSE)",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_storage_encrypted_check",
    Description: "RDS Instances storage must be encrypted",
    ErrorMessages: null,
    Status: "FAILED",
  },
];
export const Security_Q8_notebook_instance_encrypted_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_elastic_search_at_rest_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_notebook_instance_KMS_CMK_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_lambda_environment_variables_cmk_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_environment_variables_cmk_encryption_check",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "3232042d-81e5-41b3-8826-1c119e04a5a4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that your Amazon Lambda environment variables are using customer-managed Customer Master Keys (CMKs) instead of AWS managed-keys (i.e. default keys used when there are no customer keys defined) in order to benefit from a more granular control over the data encryption and decryption process.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_environment_variables_cmk_encryption_check",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "43a8e068-4ce0-465f-83a1-e36e3b00a7c4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that your Amazon Lambda environment variables are using customer-managed Customer Master Keys (CMKs) instead of AWS managed-keys (i.e. default keys used when there are no customer keys defined) in order to benefit from a more granular control over the data encryption and decryption process.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_environment_variables_cmk_encryption_check",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "89e86d9e-6315-4d32-a9e3-e42e03e68000",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that your Amazon Lambda environment variables are using customer-managed Customer Master Keys (CMKs) instead of AWS managed-keys (i.e. default keys used when there are no customer keys defined) in order to benefit from a more granular control over the data encryption and decryption process.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_environment_variables_cmk_encryption_check",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "a3ae959f-7bb6-4563-8fc5-a7a1c0dde466",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that your Amazon Lambda environment variables are using customer-managed Customer Master Keys (CMKs) instead of AWS managed-keys (i.e. default keys used when there are no customer keys defined) in order to benefit from a more granular control over the data encryption and decryption process.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_environment_variables_cmk_encryption_check",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "bd841d71-65e8-4710-946a-15759b4e10d2",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that your Amazon Lambda environment variables are using customer-managed Customer Master Keys (CMKs) instead of AWS managed-keys (i.e. default keys used when there are no customer keys defined) in order to benefit from a more granular control over the data encryption and decryption process.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_environment_variables_cmk_encryption_check",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "edd7e566-5e1e-47ef-a3f0-d3689ccbb77b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that your Amazon Lambda environment variables are using customer-managed Customer Master Keys (CMKs) instead of AWS managed-keys (i.e. default keys used when there are no customer keys defined) in order to benefit from a more granular control over the data encryption and decryption process.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q8_ebs_volume_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "1e30cf04-4478-4c8b-9955-0125b78466d0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-00390a16574adf858",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "6a69dc9c-c56f-4173-87bb-76aec6a9b195",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-03d385d8a15e6912b",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "6e4c34eb-1607-4c2f-aae9-d00635581fc6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0faf25aeab3cb0efa",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "8561284d-501e-4e4b-a9e7-253a865a93b2",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-03698fec3b83c21aa",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "8a2bcb59-b17b-4b64-ab76-85e44ace6265",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-05ef2b3341707c934",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "96d26e61-7861-479c-8e9b-a1a729d0ad75",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-02d23369d29e03152",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "b368c1cc-c8a9-4634-a4d3-a6d0cfd11fe1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0747ba470b9190c04",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "b5274149-c4b4-41fd-835e-9042eb8f57f7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-006628696d6276613",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "b9528f60-0fc8-423c-bafc-3edf87b8cc01",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-04519c70f234c739a",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "bf7080cb-51c2-4b60-ac44-b0ef6b38130c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Volumes to meet Security and Compliance requirements. This check verifies if EBS Volumes in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0ea6b0db4290bf8cb",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 11,
};
export const Security_Q8_S3_bucket_has_bucket_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "S3_bucket_has_bucket_policy_check",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "da9c2dc3-e553-4e54-a240-31077ca7dbe0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that S3 Bucket Policy is configured for the bucket. S3 bucket policies are used to provide an additional layer of access control for the bucket.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "S3_bucket_has_bucket_policy_check",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "2e2312c5-edc6-49e6-90c9-fcdc4a8f6282",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that S3 Bucket Policy is configured for the bucket. S3 bucket policies are used to provide an additional layer of access control for the bucket.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "S3_bucket_has_bucket_policy_check",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "4918f182-91b4-41d8-99c0-71b643aab587",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that S3 Bucket Policy is configured for the bucket. S3 bucket policies are used to provide an additional layer of access control for the bucket.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "S3_bucket_has_bucket_policy_check",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "5d016b19-23d1-44be-ad91-556d89b3c04a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that S3 Bucket Policy is configured for the bucket. S3 bucket policies are used to provide an additional layer of access control for the bucket.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "S3_bucket_has_bucket_policy_check",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "97ce79a0-ea0b-443f-88df-6a07a0143f7f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that S3 Bucket Policy is configured for the bucket. S3 bucket policies are used to provide an additional layer of access control for the bucket.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "S3_bucket_has_bucket_policy_check",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "f7dfa8ce-ee56-4dfd-8d20-83d1de22467f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that S3 Bucket Policy is configured for the bucket. S3 bucket policies are used to provide an additional layer of access control for the bucket.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Security_Q8_training_job_volume_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_workspaces_root_volume_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_emr_security_config_config_ebs_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_rds_database_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_database_encryption_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "43c81204-67e0-4239-b282-ff15caee6d79",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that RDS database instances are using KMS CMK customer-managed keys rather than AWS managed-keys (default keys used by RDS when there are no customer keys available), in order to have more granular control over your data-at-rest encryption/decryption process",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_database_encryption_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "4f6105f6-0210-4568-93ec-8be1114adb5e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that RDS database instances are using KMS CMK customer-managed keys rather than AWS managed-keys (default keys used by RDS when there are no customer keys available), in order to have more granular control over your data-at-rest encryption/decryption process",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q8_workspaces_user_volume_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_glue_data_catalog_encryption_at_rest_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "glue_data_catalog_encryption_at_rest_check",
      CreatedAt: "2023-04-25 12:25:06",
      FindingId: "063500de-4c24-456d-b6c9-347aebfcef9b",
      Metadata: {
        TaskRefId: "5912eab9-4269-4cee-a2fa-a16715fadb71",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that encryption at rest is enabled for your Amazon Glue Data Catalogs in order to meet regulatory requirements and prevent unauthorized users from getting access to sensitive data. With this feature enabled, you can encrypt AWS Glue Data Catalog objects such as databases, tables, partitions, connections and user-defined functions and also encrypt connection passwords that you provide when you create data connections",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "GlueDataCatalog",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q8_are_plaintext_env_variables_used = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_is_artifact_encryption_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_emr_security_config_encryption_at_rest_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_efs_file_system_encrypted = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_is_cache_encryption_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_cache_encryption_enabled",
      CreatedAt: "2023-04-25 12:24:15",
      FindingId: "67669ba0-e91b-4a8c-9893-11c4437ae896",
      Metadata: {
        TaskRefId: "92b01d74-b491-48fe-8deb-38af09b2c833",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation: "Ensure that cache encryption enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "is_cache_encryption_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "e6e3c04e-6898-4219-8dd2-0ee086a3dd50",
      Metadata: {
        TaskRefId: "92b01d74-b491-48fe-8deb-38af09b2c833",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation: "Ensure that cache encryption enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q8_ebs_volume_encryption_check_account_level = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_encryption_check_account_level",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "62dc8833-48c3-4a8e-999e-7b78ece7f0ac",
      Metadata: {
        TaskRefId: "15d51cb5-80ca-4cf1-ad97-f92fc5998a01",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Newly created Amazon EBS volumes aren't encrypted by default. However, you can turn on default encryption for new EBS volumes and snapshot copies that are created within a specified Region. This check verifies if the default encryption option is turned on.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "181570489212",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q8_kinesis_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "kinesis_encryption_check",
      CreatedAt: "2023-04-25 12:24:15",
      FindingId: "41df874a-a59f-4f24-8993-25716a70bedb",
      Metadata: {
        TaskRefId: "df33b1c1-8057-4030-bc1b-adf9b5deded6",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to ensure Kinesis Data Streams are encrypted. This check verifies if Kinesis stream is encrypted at rest with server-side encryption.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "warf-stream-ba174a80-e354-11ed-8812-0e70d921958f",
      ResourceType: "Kinesis",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q8_crawler_cloudwatch_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_documentdb_cluster_aws_kms_cmk_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_sqs_queue_sse_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_documentdb_cluster_snapshot_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_broker_kms_cmk_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_ebs_snapshot_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_encryption_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "915def67-c8c7-4fc8-bff8-ce9effc0acd5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Snapshots to meet Security and Compliance requirements. This check verifies if EBS Snapshots in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "snap-0fefb040fa59d91ac",
      ResourceType: "Snapshot",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_encryption_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "d0dcd76e-5533-4bd6-b455-a29ae1606ca1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt EBS Snapshots to meet Security and Compliance requirements. This check verifies if EBS Snapshots in your AWS Accounts are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "snap-08155855243ecf2be",
      ResourceType: "Snapshot",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q8_documentdb_instance_encrypted = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "documentdb_instance_encrypted",
      CreatedAt: "2023-04-25 12:24:52",
      FindingId: "cdde3b3b-6ce2-4066-ac22-4eefdd6cddb7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that encryption is enabled for your AWS DocumentDB (with MongoDB compatibility) clusters for additional data security and in order to meet compliance requirements for data-at-rest encryption.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "DocumentDBInstance",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "documentdb_instance_encrypted",
      CreatedAt: "2023-04-25 12:24:52",
      FindingId: "fd75bf2a-3a61-421b-8618-991f2f607450",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that encryption is enabled for your AWS DocumentDB (with MongoDB compatibility) clusters for additional data security and in order to meet compliance requirements for data-at-rest encryption.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "wartestrds1noncompliant-181570489212",
      ResourceType: "DocumentDBInstance",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q8_neptune_instance_at_rest_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_elasticache_redis_at_rest_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_redshift_encryption_status_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_encrypted_ami_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "encrypted_ami_check",
      CreatedAt: "2023-04-25 12:24:41",
      FindingId: "2a50b03d-4846-4d6c-ab88-8f17f5b4f9fd",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation: "Ensure Amazon Machine Images(AMIS) are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-092c18574fce16603",
      ResourceType: "Image",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "encrypted_ami_check",
      CreatedAt: "2023-04-25 12:24:41",
      FindingId: "5f88e81d-b0d5-4325-a218-e089062b5328",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation: "Ensure Amazon Machine Images(AMIS) are encrypted.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-0a8d4563854aec173",
      ResourceType: "Image",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Security_Q8_kms_key_policy_public_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_glue_security_configuration_job_bookmark_encryption_check =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [],
    TotalRecords: 0,
  };
export const Security_Q8_codebuild_s3_logging_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_sqs_resource_based_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q8_sns_topic_sse_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_sse_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "20167c0b-0b06-40f8-9e82-3b117ead1963",
      Metadata: {
        TaskRefId: "007f69da-7bbe-4a77-bcfb-6806b45af159",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that Server-Side Encryption (SSE) is enabled for your AWS Simple Notification Service (SNS) topics for additional protection of sensitive data delivered as messages to subscribers. With the SSE feature enabled, when messages are published to encrypted topics, AWS SNS immediately encrypts the messages using a 256-bit AES-GCM algorithm, AWS SNS Server-Side Encryption can work with both AWS-managed CMKs and customer-managed CMKs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_sse_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "8560a594-6a09-4a14-af5d-a7045b9684c7",
      Metadata: {
        TaskRefId: "007f69da-7bbe-4a77-bcfb-6806b45af159",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that Server-Side Encryption (SSE) is enabled for your AWS Simple Notification Service (SNS) topics for additional protection of sensitive data delivered as messages to subscribers. With the SSE feature enabled, when messages are published to encrypted topics, AWS SNS immediately encrypts the messages using a 256-bit AES-GCM algorithm, AWS SNS Server-Side Encryption can work with both AWS-managed CMKs and customer-managed CMKs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:sns:us-east-1:181570489212:war-test-9b1e",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_sse_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "9724de12-6b2b-4260-870a-3c2e7dc1ae56",
      Metadata: {
        TaskRefId: "007f69da-7bbe-4a77-bcfb-6806b45af159",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that Server-Side Encryption (SSE) is enabled for your AWS Simple Notification Service (SNS) topics for additional protection of sensitive data delivered as messages to subscribers. With the SSE feature enabled, when messages are published to encrypted topics, AWS SNS immediately encrypts the messages using a 256-bit AES-GCM algorithm, AWS SNS Server-Side Encryption can work with both AWS-managed CMKs and customer-managed CMKs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_sse_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "f62007da-88a9-4563-8cc6-f2ac06ad713d",
      Metadata: {
        TaskRefId: "007f69da-7bbe-4a77-bcfb-6806b45af159",
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "Ensure that Server-Side Encryption (SSE) is enabled for your AWS Simple Notification Service (SNS) topics for additional protection of sensitive data delivered as messages to subscribers. With the SSE feature enabled, when messages are published to encrypted topics, AWS SNS immediately encrypts the messages using a 256-bit AES-GCM algorithm, AWS SNS Server-Side Encryption can work with both AWS-managed CMKs and customer-managed CMKs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-OnBoarding-Topic",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q8_rds_storage_encrypted_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_storage_encrypted_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "1f799b44-2a1f-4a8b-8f2e-4d1b5d250da1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt RDS instances to meet Security and Compliance requirements This check identifies RDS instances in your AWS Accounts and verifies if they are encrypted at rest.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_storage_encrypted_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "e8b433cd-1c1d-41ae-a11c-e3f8f76dd626",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-rest",
      Recommendation:
        "It is a best practice to encrypt RDS instances to meet Security and Compliance requirements This check identifies RDS instances in your AWS Accounts and verifies if they are encrypted at rest.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Security_Q9_Check_Details = [
  {
    CheckId: "sns_http_subscription_check",
    Description: "SNS topic have plaintext (HTTP) subscriptions",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "client_broker_encryption_in_transit_check",
    Description: "MSK client-broker communications TLS-only",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "aws_certificate_logging_check",
    Description: "ACM Certificate Transparency logging should be enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "sagemaker_endpoint_encryption_check",
    Description:
      "AWS SageMaker Endpoint should be encrypted as you store sensitive information on the ML storage volume. By applying encryption at-rest you ensure that the data stored on your AWS SageMaker Endpoint meets regulatory requirements and is less likely to be lo",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "node2node_encryption_check",
    Description: "Elasticsearch Node2Node encryption",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "appmesh_virt_node_backed_default_tls_policy_check",
    Description: "Does the backend default client policy enforce TLS",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "security_group_inbound_allow_ports_check",
    Description:
      "Ensure Security Groups accept traffic only from ports 80 and 443 from internet",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "qldb_export_export_encryption_check",
    Description: "QLDB export encryption enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "appmesh_virt_node_listener_strict_tls_check",
    Description:
      "App Mesh virtual node backends have STRICT TLS mode configured for inbound connections",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "emr_security_config_encryption_in_transit_check",
    Description: "EMR In-Transit Encryption",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "kinesis_firehose_delivery_stream_encryption_enabled",
    Description:
      "Ensure that delivery stream encryption enabled on Kinesis Firehose",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "tls_policy_check",
    Description: "Elasticsearch domain endpoint is using outdated TLS policy.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_connection_pwd_encrypt_configure",
    Description:
      "Ensure that Amazon Glue Data Catalog objects and connection passwords are encrypted.",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "inter_cluster_encryption_in_transit_check",
    Description: "MSK cluster encryption at rest and in transit is not enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloudfront_cdn_encryption_check",
    Description: "CloudFront Viewer Protocol Policy",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "codebuild_insecure_ssl_check",
    Description: "CodeBuild projects should not have insecure SSL configured",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elasticache_redis_in_transit_encryption_check",
    Description:
      "Ensure AWS ElastiCache Redis clusters have in-transit encryption enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "https_enforcement_check",
    Description: "Elasticsearch HTTPS-only enforced",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "client_authentication_check",
    Description: "MSK Private CA TLS auth used",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "guard_duty_s3_protection_check",
    Description: "Amazon S3 Protection in Amazon GuardDuty",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_secure_request_check",
    Description: "S3 bucket should allow only HTTPS requests",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "emr_clusters_security_configuration_attached_check",
    Description: "EMR clusters should have a security configuration attached",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Security_Q9_sns_http_subscription_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "sns_http_subscription_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "9505db09-1010-419d-8a97-d3968b42204e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Ensure that none of the Amazon SNS subscriptions created within your AWS account are using HTTP instead of HTTPS as delivery protocol in order to enforce SSL encryption for all subscription requests.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:sns:us-east-1:181570489212:war-test-9b1e",
      ResourceType: "Topic",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_http_subscription_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "1109d874-b05f-401f-ba26-a04aef3d52e6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Ensure that none of the Amazon SNS subscriptions created within your AWS account are using HTTP instead of HTTPS as delivery protocol in order to enforce SSL encryption for all subscription requests.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_http_subscription_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "5d181f25-a2b3-4bca-8a44-ae6b6053caca",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Ensure that none of the Amazon SNS subscriptions created within your AWS account are using HTTP instead of HTTPS as delivery protocol in order to enforce SSL encryption for all subscription requests.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-OnBoarding-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_http_subscription_check",
      CreatedAt: "2023-04-25 12:23:29",
      FindingId: "6bc0e60c-140f-40f4-9720-82468fa65f2b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Ensure that none of the Amazon SNS subscriptions created within your AWS account are using HTTP instead of HTTPS as delivery protocol in order to enforce SSL encryption for all subscription requests.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Security_Q9_client_broker_encryption_in_transit_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_aws_certificate_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_sagemaker_endpoint_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_node2node_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_appmesh_virt_node_backed_default_tls_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_security_group_inbound_allow_ports_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "f707d117-a8c8-4afe-afa7-f5d1a507ed73",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-063466d0b4e1fbf57",
      ResourceType: "SecurityGroup",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "1bbe4429-50d6-4787-960f-83d78a0c73ec",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-095358f4cdcc3b15d",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "4e90f838-f4a2-4285-a83a-db78a901741d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0ab1a85e19843d7cf",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "69d61d11-d9cd-4929-955e-52052c044408",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-063fc5265799cc140",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "86092660-829d-49f9-a56a-c3d5cc65ab8d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-04ac3ddd2255407e3",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "94a6a5a2-f44f-41b2-b538-a85ae9ecec42",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0e4dc6de178b855a0",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "f2041d30-3a15-4b6d-ae5e-2a1f3ea0d606",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-09d089b8e9938d9e0",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "f77c3bb9-00b1-49aa-b893-02b72002df16",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0b1eeca42f8181b58",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "security_group_inbound_allow_ports_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "f81f8834-b460-41fa-aa48-b7a7b2f934d6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Do not allow global access to well-known ports of an EC2 instance directly (except for 80 and 443)",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "sg-0344a99f2eb9135f2",
      ResourceType: "SecurityGroup",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 9,
};
export const Security_Q9_qldb_export_export_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_appmesh_virt_node_listener_strict_tls_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_emr_security_config_encryption_in_transit_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_kinesis_firehose_delivery_stream_encryption_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_tls_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_is_connection_pwd_encrypt_configure = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_connection_pwd_encrypt_configure",
      CreatedAt: "2023-04-25 12:25:06",
      FindingId: "af67a93a-57a0-48d2-b176-0ac32feb981c",
      Metadata: {
        TaskRefId: "767f53ad-3147-49b9-abf3-9abbc6514026",
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "Ensure that Amazon Glue Data Catalog objects and connection passwords are encrypted.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "GlueDataCatalog",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Security_Q9_inter_cluster_encryption_in_transit_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_cloudfront_cdn_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_codebuild_insecure_ssl_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_elasticache_redis_in_transit_encryption_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_https_enforcement_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_client_authentication_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_guard_duty_s3_protection_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Security_Q9_s3_bucket_secure_request_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "13513d32-ce64-4222-bca1-5d55dd255ba6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "1bb5bd6e-2ebd-4f36-a352-46ad19423be0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "28dd3d82-92a5-4e6d-847f-b1c48bf7ad7a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "2efcda39-1069-4522-b68a-0ae3312ab67b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "39eae7ea-1884-4c62-a17c-ec2b294074ea",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "433204ab-dd82-4286-a8f1-da64fbd86569",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "434a3321-8a3c-4956-8523-b6d55786ec8e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "5a2c971a-6afe-4781-8710-83c435577539",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "60c319b4-511d-404e-99d6-ba7a03f5e6d6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_secure_request_check",
      CreatedAt: "2023-04-25 12:23:52",
      FindingId: "624cca1c-2eac-4d04-aa4b-39266e1a060d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "security",
      QuestionId: "protect-data-transit",
      Recommendation:
        "By default, Amazon S3 allows both HTTP and HTTPS requests. To achieve only allowing access to Amazon S3 objects through HTTPS you also have to explicitly deny access to HTTP requests. Bucket policies that allow HTTPS requests without explicitly denying HTTP requests will not comply with this recommendation.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 21,
};
export const Security_Q9_emr_clusters_security_configuration_attached_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const securityCheckFindings = {
  [`securely-operate_amazon_macie_in_use_check`]:
    Security_Q1_amazon_macie_in_use_check,
  [`securely-operate_iam_password_uppercase_check`]:
    Security_Q1_iam_password_uppercase_check,
  [`securely-operate_secret_age_check`]: Security_Q1_secret_age_check,
  [`securely-operate_security_hub_enable_check`]:
    Security_Q1_security_hub_enable_check,
  [`securely-operate_iam_user_inline_policy_check`]:
    Security_Q1_iam_user_inline_policy_check,
  [`securely-operate_iam_password_lowercase_check`]:
    Security_Q1_iam_password_lowercase_check,
  [`securely-operate_iam_password_policy_cis_check`]:
    Security_Q1_iam_password_policy_cis_check,
  [`securely-operate_iam_password_age_check`]:
    Security_Q1_iam_password_age_check,
  [`securely-operate_kms_cmk_keystate_check`]:
    Security_Q1_kms_cmk_keystate_check,
  [`securely-operate_iam_password_length_check`]:
    Security_Q1_iam_password_length_check,
  [`securely-operate_iam_support_role_check`]:
    Security_Q1_iam_support_role_check,
  [`securely-operate_iam_multiple_active_accesskey_check`]:
    Security_Q1_iam_multiple_active_accesskey_check,
  [`securely-operate_iam_user_first_access_key_check`]:
    Security_Q1_iam_user_first_access_key_check,
  [`securely-operate_security_hub_cis_enable_check`]:
    Security_Q1_security_hub_cis_enable_check,
  [`securely-operate_iam_password_symbol_check`]:
    Security_Q1_iam_password_symbol_check,
  [`securely-operate_iam_user_second_access_key_check`]:
    Security_Q1_iam_user_second_access_key_check,
  [`securely-operate_iam_role_policies_check`]:
    Security_Q1_iam_role_policies_check,
  [`securely-operate_securityhub_foundational_security_enable_check`]:
    Security_Q1_securityhub_foundational_security_enable_check,
  [`securely-operate_no_root_account_access_key_check`]:
    Security_Q1_no_root_account_access_key_check,
  [`securely-operate_iam_user_access_key_check`]:
    Security_Q1_iam_user_access_key_check,
  [`securely-operate_cognito_identity_pool_password_policy`]:
    Security_Q1_cognito_identity_pool_password_policy,
  [`securely-operate_cognito_temporary_password_age_check`]:
    Security_Q1_cognito_temporary_password_age_check,
  [`securely-operate_iam_assume_role_check`]: Security_Q1_iam_assume_role_check,
  [`securely-operate_iam_password_number_check`]:
    Security_Q1_iam_password_number_check,
  [`securely-operate_unused_function_check`]: Security_Q1_unused_function_check,
  [`identities_directory_service_radius_check`]:
    Security_Q2_directory_service_radius_check,
  [`identities_secrets_manager_is_secret_auto_rotation_enabled`]:
    Security_Q2_secrets_manager_is_secret_auto_rotation_enabled,
  [`identities_rds_instance_iam_auth_check`]:
    Security_Q2_rds_instance_iam_auth_check,
  [`identities_cognito_identity_pool_enforce_mfa`]:
    Security_Q2_cognito_identity_pool_enforce_mfa,
  [`identities_neptune_instance_iam_authentication_check`]:
    Security_Q2_neptune_instance_iam_authentication_check,
  [`identities_iam_user_permission_check`]:
    Security_Q2_iam_user_permission_check,
  [`identities_iam_user_mfa_check`]: Security_Q2_iam_user_mfa_check,
  [`identities_rds_instance_domain_join_check`]:
    Security_Q2_rds_instance_domain_join_check,
  [`permissions_sns_cross_account_check`]: Security_Q3_sns_cross_account_check,
  [`permissions_lambda_admin_privilege_check`]:
    Security_Q3_lambda_admin_privilege_check,
  [`permissions_ecs_role_task_check`]: Security_Q3_ecs_role_task_check,
  [`permissions_s3_bucket_should_not_be_world_listable`]:
    Security_Q3_s3_bucket_should_not_be_world_listable,
  [`permissions_s3_bucket_list_action_all_principal_check`]:
    Security_Q3_s3_bucket_list_action_all_principal_check,
  [`permissions_does_resource_allow_external_principals`]:
    Security_Q3_does_resource_allow_external_principals,
  [`permissions_lambda_function_public_check`]:
    Security_Q3_lambda_function_public_check,
  [`permissions_elastic_search_domain_public_check`]:
    Security_Q3_elastic_search_domain_public_check,
  [`permissions_shield_advanced_drt_access_check`]:
    Security_Q3_shield_advanced_drt_access_check,
  [`permissions_elasticache_redis_cluster_auth_token`]:
    Security_Q3_elasticache_redis_cluster_auth_token,
  [`permissions_cognito_check`]: Security_Q3_cognito_check,
  [`permissions_emr_security_config_kerberos_check`]:
    Security_Q3_emr_security_config_kerberos_check,
  [`permissions_s3_bucket_put_action_check`]:
    Security_Q3_s3_bucket_put_action_check,
  [`permissions_sns_public_topic_check`]: Security_Q3_sns_public_topic_check,
  [`permissions_s3_bucket_withoutcondition_action_all_check`]:
    Security_Q3_s3_bucket_withoutcondition_action_all_check,
  [`permissions_s3_bucket_list_action_check`]:
    Security_Q3_s3_bucket_list_action_check,
  [`permissions_s3_bucket_delete_action_all_principal_check`]:
    Security_Q3_s3_bucket_delete_action_all_principal_check,
  [`permissions_s3_bucket_should_not_be_world_writable`]:
    Security_Q3_s3_bucket_should_not_be_world_writable,
  [`permissions_glue_data_catalog_resource_policy_check`]:
    Security_Q3_glue_data_catalog_resource_policy_check,
  [`permissions_ec2_iam_role_check`]: Security_Q3_ec2_iam_role_check,
  [`permissions_s3_bucket_delete_action_check`]:
    Security_Q3_s3_bucket_delete_action_check,
  [`permissions_s3_bucket_put_action_without_condition_check`]:
    Security_Q3_s3_bucket_put_action_without_condition_check,
  [`permissions_rds_snapshot_public_access_check`]:
    Security_Q3_rds_snapshot_public_access_check,
  [`permissions_ecr_public_repo_check`]: Security_Q3_ecr_public_repo_check,
  [`permissions_s3_bucket_should_not_be_world_listable_by_anonymous_user`]:
    Security_Q3_s3_bucket_should_not_be_world_listable_by_anonymous_user,
  [`permissions_lambda_same_iam_execution_role_check`]:
    Security_Q3_lambda_same_iam_execution_role_check,
  [`permissions_s3_bucket_get_action_all_principal_check`]:
    Security_Q3_s3_bucket_get_action_all_principal_check,
  [`permissions_s3_bucket_get_action_check`]:
    Security_Q3_s3_bucket_get_action_check,
  [`permissions_s3_bucket_anonymous_user_write_check`]:
    Security_Q3_s3_bucket_anonymous_user_write_check,
  [`permissions_appstream_users_use_saml_authentication`]:
    Security_Q3_appstream_users_use_saml_authentication,
  [`permissions_s3_bucket_all_action_check`]:
    Security_Q3_s3_bucket_all_action_check,
  [`detect-investigate-events_broker_general_logging_check`]:
    Security_Q4_broker_general_logging_check,
  [`detect-investigate-events_log_metric_filter_for_unauthorized_api_call_changes`]:
    Security_Q4_log_metric_filter_for_unauthorized_api_call_changes,
  [`detect-investigate-events_log_metric_filter_for_iam_policy_changes`]:
    Security_Q4_log_metric_filter_for_iam_policy_changes,
  [`detect-investigate-events_cluster_audit_logging_on`]:
    Security_Q4_documentdb_cluster_audit_logging_on,
  [`detect-investigate-events_cloud_trail_log_file_validation`]:
    Security_Q4_cloud_trail_log_file_validation,
  [`detect-investigate-events_elb_access_logging_check`]:
    Security_Q4_elb_access_logging_check,
  [`detect-investigate-events_elbv2_nlb_tls_logging_check`]:
    Security_Q4_elbv2_nlb_tls_logging_check,
  [`detect-investigate-events_redshift_cluster_logging_check`]:
    Security_Q4_redshift_cluster_logging_check,
  [`detect-investigate-events_is_cloudwatch_logging_enabled`]:
    Security_Q4_is_cloudwatch_logging_enabled,
  [`detect-investigate-events_kms_key_rotation_enabled`]:
    Security_Q4_kms_key_rotation_enabled,
  [`detect-investigate-events_emr_cluster_logging_check`]:
    Security_Q4_emr_cluster_logging_check,
  [`detect-investigate-events_log_metric_filter_for_aws_config_changes`]:
    Security_Q4_log_metric_filter_for_aws_config_changes,
  [`detect-investigate-events_clb_access_logging_check`]:
    Security_Q4_clb_access_logging_check,
  [`detect-investigate-events_log_metric_filter_for_security_group_changes`]:
    Security_Q4_log_metric_filter_for_security_group_changes,
  [`detect-investigate-events_high_critical_findings`]:
    Security_Q4_high_critical_findings,
  [`detect-investigate-events_cloud_trail_s3_bucket_publicly_accessible_check`]:
    Security_Q4_cloud_trail_s3_bucket_publicly_accessible_check,
  [`detect-investigate-events_log_metric_filter_for_route_table_changes`]:
    Security_Q4_log_metric_filter_for_route_table_changes,
  [`detect-investigate-events_is_stage_api_logging_enabled`]:
    Security_Q4_is_stage_api_logging_enabled,
  [`detect-investigate-events_are_global_management_events_logged`]:
    Security_Q4_are_global_management_events_logged,
  [`detect-investigate-events_neptune_cluster_audit_logging_check`]:
    Security_Q4_neptune_cluster_audit_logging_check,
  [`detect-investigate-events_blockchain_fabric_peer_node_logs_enabled`]:
    Security_Q4_blockchain_fabric_peer_node_logs_enabled,
  [`detect-investigate-events_cloudtrail_logs_encrypted_at_rest`]:
    Security_Q4_cloudtrail_logs_encrypted_at_rest,
  [`detect-investigate-events_cloud_trail_multi_region`]:
    Security_Q4_cloud_trail_multi_region,
  [`detect-investigate-events_kinesis_kms_key_rotation_check`]:
    Security_Q4_kinesis_kms_key_rotation_check,
  [`detect-investigate-events_is_cloudwatch_log_forwarding_enabled`]:
    Security_Q4_is_cloudwatch_log_forwarding_enabled,
  [`detect-investigate-events_rds_instance_cloudwatch_logging_check`]:
    Security_Q4_rds_instance_cloudwatch_logging_check,
  [`detect-investigate-events_log_metric_filter_for_network_gateway_changes`]:
    Security_Q4_log_metric_filter_for_network_gateway_changes,
  [`detect-investigate-events_amb_fabric_member_ca_logging_check`]:
    Security_Q4_amb_fabric_member_ca_logging_check,
  [`detect-investigate-events_appmesh_logging_check`]:
    Security_Q4_appmesh_logging_check,
  [`detect-investigate-events_is_detective_enabled`]:
    Security_Q4_is_detective_enabled,
  [`detect-investigate-events_s3_enable_mfa_delete_check`]:
    Security_Q4_s3_enable_mfa_delete_check,
  [`detect-investigate-events_log_metric_filter_for_cmk_api_call_changes`]:
    Security_Q4_log_metric_filter_for_cmk_api_call_changes,
  [`detect-investigate-events_log_metric_filter_for_vpc_changes`]:
    Security_Q4_log_metric_filter_for_vpc_changes,
  [`detect-investigate-events_amb_fabric_node_chaincode_logging_check`]:
    Security_Q4_amb_fabric_node_chaincode_logging_check,
  [`detect-investigate-events_configuration_status_check`]:
    Security_Q4_configuration_status_check,
  [`detect-investigate-events_documentdb_cluster_audit_logs_check`]:
    Security_Q4_documentdb_cluster_audit_logs_check,
  [`detect-investigate-events_vpc_flow_log_enabled_check`]:
    Security_Q4_vpc_flow_log_enabled_check,
  [`detect-investigate-events_kinesis_analytics_application_log_to_cloudwatch_check`]:
    Security_Q4_kinesis_analytics_application_log_to_cloudwatch_check,
  [`detect-investigate-events_s3_bucket_logging_enable`]:
    Security_Q4_s3_bucket_logging_enable,
  [`detect-investigate-events_log_metric_filter_for_without_mfa_signin_changes`]:
    Security_Q4_log_metric_filter_for_without_mfa_signin_changes,
  [`detect-investigate-events_cloud_trail_cloud_watch_log_enabled`]:
    Security_Q4_cloud_trail_cloud_watch_log_enabled,
  [`detect-investigate-events_broker_audit_logging_check`]:
    Security_Q4_broker_audit_logging_check,
  [`detect-investigate-events_log_metric_filter_for_s3_changes`]:
    Security_Q4_log_metric_filter_for_s3_changes,
  [`detect-investigate-events_log_metric_filter_for_console_authentication_failure`]:
    Security_Q4_log_metric_filter_for_console_authentication_failure,
  [`detect-investigate-events_vpc_route_resolver_query_check`]:
    Security_Q4_vpc_route_resolver_query_check,
  [`detect-investigate-events_eks_cluster_control_plane_logging_check`]:
    Security_Q4_eks_cluster_control_plane_logging_check,
  [`detect-investigate-events_documentdb_cluster_delete_protection_check`]:
    Security_Q4_documentdb_cluster_delete_protection_check,
  [`detect-investigate-events_log_metric_filter_for_aws_cloud_trail_changes`]:
    Security_Q4_log_metric_filter_for_aws_cloud_trail_changes,
  [`detect-investigate-events_api_gateway_access_logging_check`]:
    Security_Q4_api_gateway_access_logging_check,
  [`detect-investigate-events_api_gateway_stage_metrics_enabled_check`]:
    Security_Q4_api_gateway_stage_metrics_enabled_check,
  [`detect-investigate-events_compromise_appstream_user_check`]:
    Security_Q4_compromise_appstream_user_check,
  [`detect-investigate-events_ecs_cluster_registration_check`]:
    Security_Q4_ecs_cluster_registration_check,
  [`detect-investigate-events_log_metric_filter_for_root_account_changes`]:
    Security_Q4_log_metric_filter_for_root_account_changes,
  [`detect-investigate-events_log_metric_filter_for_nacl_changes`]:
    Security_Q4_log_metric_filter_for_nacl_changes,
  [`detect-investigate-events_cloudtrail_mfa_delete_check`]:
    Security_Q4_cloudtrail_mfa_delete_check,
  [`protect-compute_security_group_restrict_outbound_traffic_check`]:
    Security_Q6_security_group_restrict_outbound_traffic_check,
  [`protect-compute_s3_bucket_version_enable`]:
    Security_Q6_s3_bucket_version_enable,
  [`protect-compute_image_public_check`]: Security_Q6_image_public_check,
  [`protect-compute_notebook_instance_in_vpc_check`]:
    Security_Q6_notebook_instance_in_vpc_check,
  [`protect-compute_elbv2_tls12_listener_policy_check`]:
    Security_Q6_elbv2_tls12_listener_policy_check,
  [`protect-compute_waf_regional_acls_logging_check`]:
    Security_Q6_waf_regional_acls_logging_check,
  [`protect-compute_rds_instance_deletion_protection_check`]:
    Security_Q6_rds_instance_deletion_protection_check,
  [`protect-compute_cloudfront_cdn_logging_service_check`]:
    Security_Q6_cloudfront_cdn_logging_service_check,
  [`protect-compute_documentdb_cluster_snapshot_public_share_check`]:
    Security_Q6_documentdb_cluster_snapshot_public_share_check,
  [`protect-compute_security_group_inbound_remote_server_ports_check`]:
    Security_Q6_security_group_inbound_remote_server_ports_check,
  [`protect-compute_default_security_group_restricts_all_traffic_check`]:
    Security_Q6_default_security_group_restricts_all_traffic_check,
  [`protect-compute_cloudfront_cdn_service_geo_info_check`]:
    Security_Q6_cloudfront_cdn_service_geo_info_check,
  [`protect-compute_elb_internet_facing_secure_listeners_check`]:
    Security_Q6_elb_internet_facing_secure_listeners_check,
  [`protect-compute_redshift_cluster_public_access_check`]:
    Security_Q6_redshift_cluster_public_access_check,
  [`protect-compute_notebook_instance_direct_internet_access_check`]:
    Security_Q6_notebook_instance_direct_internet_access_check,
  [`protect-compute_s3_static_website_hosting_check`]:
    Security_Q6_s3_static_website_hosting_check,
  [`protect-compute_api_gateway_private_check`]:
    Security_Q6_api_gateway_private_check,
  [`protect-compute_security_group_rdp_port_open_to_internet`]:
    Security_Q6_security_group_rdp_port_open_to_internet,
  [`protect-compute_cloudfront_cdn_service_check`]:
    Security_Q6_cloudfront_cdn_service_check,
  [`protect-compute_ec2_imdsv2_check`]: Security_Q6_ec2_imdsv2_check,
  [`protect-compute_security_group_all_open_check`]:
    Security_Q6_security_group_all_open_check,
  [`protect-compute_ecs_cluster_with_unconnected_agents_check`]:
    Security_Q6_ecs_cluster_with_unconnected_agents_check,
  [`protect-compute_vpc_flow_log_enabled_check`]:
    Security_Q6_vpc_flow_log_enabled_check,
  [`protect-compute_qldb_deletion_protection_check`]:
    Security_Q6_qldb_deletion_protection_check,
  [`protect-compute_rds_public_access_check`]:
    Security_Q6_rds_public_access_check,
  [`protect-compute_cloudfront_waf_intergration_check`]:
    Security_Q6_cloudfront_waf_intergration_check,
  [`protect-compute_s3_bucket_are_not_public`]:
    Security_Q6_s3_bucket_are_not_public,
  [`protect-compute_ec2_instance_SSM_successful_association_check`]:
    Security_Q6_ec2_instance_SSM_successful_association_check,
  [`protect-compute_emr_cluster_termination_protection_check`]:
    Security_Q6_emr_cluster_termination_protection_check,
  [`protect-compute_appstream_public_images`]:
    Security_Q6_appstream_public_images,
  [`protect-compute_subnet_public_ip_assignment_check`]:
    Security_Q6_subnet_public_ip_assignment_check,
  [`protect-compute_waf_global_acls_logging_check`]:
    Security_Q6_waf_global_acls_logging_check,
  [`protect-data-rest_notebook_instance_encrypted_check`]:
    Security_Q8_notebook_instance_encrypted_check,
  [`protect-data-rest_elastic_search_at_rest_encryption_check`]:
    Security_Q8_elastic_search_at_rest_encryption_check,
  [`protect-data-rest_notebook_instance_KMS_CMK_encryption_check`]:
    Security_Q8_notebook_instance_KMS_CMK_encryption_check,
  [`protect-data-rest_lambda_environment_variables_cmk_encryption_check`]:
    Security_Q8_lambda_environment_variables_cmk_encryption_check,
  [`protect-data-rest_ebs_volume_encryption_check`]:
    Security_Q8_ebs_volume_encryption_check,
  [`protect-data-rest_S3_bucket_has_bucket_policy_check`]:
    Security_Q8_S3_bucket_has_bucket_policy_check,
  [`protect-data-rest_training_job_volume_encryption_check`]:
    Security_Q8_training_job_volume_encryption_check,
  [`protect-data-rest_workspaces_root_volume_encryption_check`]:
    Security_Q8_workspaces_root_volume_encryption_check,
  [`protect-data-rest_emr_security_config_config_ebs_encryption_check`]:
    Security_Q8_emr_security_config_config_ebs_encryption_check,
  [`protect-data-rest_rds_database_encryption_check`]:
    Security_Q8_rds_database_encryption_check,
  [`protect-data-rest_workspaces_user_volume_encryption_check`]:
    Security_Q8_workspaces_user_volume_encryption_check,
  [`protect-data-rest_glue_data_catalog_encryption_at_rest_check`]:
    Security_Q8_glue_data_catalog_encryption_at_rest_check,
  [`protect-data-rest_are_plaintext_env_variables_used`]:
    Security_Q8_are_plaintext_env_variables_used,
  [`protect-data-rest_is_artifact_encryption_enabled`]:
    Security_Q8_is_artifact_encryption_enabled,
  [`protect-data-rest_emr_security_config_encryption_at_rest_check`]:
    Security_Q8_emr_security_config_encryption_at_rest_check,
  [`protect-data-rest_efs_file_system_encrypted`]:
    Security_Q8_efs_file_system_encrypted,
  [`protect-data-rest_is_cache_encryption_enabled`]:
    Security_Q8_is_cache_encryption_enabled,
  [`protect-data-rest_ebs_volume_encryption_check_account_level`]:
    Security_Q8_ebs_volume_encryption_check_account_level,
  [`protect-data-rest_kinesis_encryption_check`]:
    Security_Q8_kinesis_encryption_check,
  [`protect-data-rest_crawler_cloudwatch_encryption_check`]:
    Security_Q8_crawler_cloudwatch_encryption_check,
  [`protect-data-rest_documentdb_cluster_aws_kms_cmk_encryption_check`]:
    Security_Q8_documentdb_cluster_aws_kms_cmk_encryption_check,
  [`protect-data-rest_sqs_queue_sse_check`]: Security_Q8_sqs_queue_sse_check,
  [`protect-data-rest_documentdb_cluster_snapshot_encryption_check`]:
    Security_Q8_documentdb_cluster_snapshot_encryption_check,
  [`protect-data-rest_broker_kms_cmk_check`]: Security_Q8_broker_kms_cmk_check,
  [`protect-data-rest_ebs_snapshot_encryption_check`]:
    Security_Q8_ebs_snapshot_encryption_check,
  [`protect-data-rest_documentdb_instance_encrypted`]:
    Security_Q8_documentdb_instance_encrypted,
  [`protect-data-rest_neptune_instance_at_rest_encryption_check`]:
    Security_Q8_neptune_instance_at_rest_encryption_check,
  [`protect-data-rest_elasticache_redis_at_rest_encryption_check`]:
    Security_Q8_elasticache_redis_at_rest_encryption_check,
  [`protect-data-rest_redshift_encryption_status_check`]:
    Security_Q8_redshift_encryption_status_check,
  [`protect-data-rest_encrypted_ami_check`]: Security_Q8_encrypted_ami_check,
  [`protect-data-rest_kms_key_policy_public_check`]:
    Security_Q8_kms_key_policy_public_check,
  [`protect-data-rest_glue_security_configuration_job_bookmark_encryption_check`]:
    Security_Q8_glue_security_configuration_job_bookmark_encryption_check,
  [`protect-data-rest_codebuild_s3_logging_encryption_check`]:
    Security_Q8_codebuild_s3_logging_encryption_check,
  [`protect-data-rest_sqs_resource_based_policy_check`]:
    Security_Q8_sqs_resource_based_policy_check,
  [`protect-data-rest_sns_topic_sse_check`]: Security_Q8_sns_topic_sse_check,
  [`protect-data-rest_rds_storage_encrypted_check`]:
    Security_Q8_rds_storage_encrypted_check,
  [`data-classification_api_gateway_key_method_request_check`]:
    Security_Q7_api_gateway_key_method_request_check,
  [`data-classification_aws_certificate_describe_check`]:
    Security_Q7_aws_certificate_describe_check,
  [`data-classification_cloudfront_security_check`]:
    Security_Q7_cloudfront_security_check,
  [`data-classification_aws_certificate_usage_check`]:
    Security_Q7_aws_certificate_usage_check,
  [`data-classification_s3_bucket_lifecycle_check`]:
    Security_Q7_s3_bucket_lifecycle_check,
  [`data-classification_aws_certificate_wildcard_check`]:
    Security_Q7_aws_certificate_wildcard_check,
  [`data-classification_are_any_server_certificates_stored_by_iam`]:
    Security_Q7_are_any_server_certificates_stored_by_iam,
  [`data-classification_elb_internet_facing_secure_listeners_check`]:
    Security_Q7_elb_internet_facing_secure_listeners_check,

  [`protect-data-transit_sns_http_subscription_check`]:
    Security_Q9_sns_http_subscription_check,
  [`protect-data-transit_client_broker_encryption_in_transit_check`]:
    Security_Q9_client_broker_encryption_in_transit_check,
  [`protect-data-transit_aws_certificate_logging_check`]:
    Security_Q9_aws_certificate_logging_check,
  [`protect-data-transit_sagemaker_endpoint_encryption_check`]:
    Security_Q9_sagemaker_endpoint_encryption_check,
  [`protect-data-transit_node2node_encryption_check`]:
    Security_Q9_node2node_encryption_check,
  [`protect-data-transit_appmesh_virt_node_backed_default_tls_policy_check`]:
    Security_Q9_appmesh_virt_node_backed_default_tls_policy_check,
  [`protect-data-transit_security_group_inbound_allow_ports_check`]:
    Security_Q9_security_group_inbound_allow_ports_check,
  [`protect-data-transit_qldb_export_export_encryption_check`]:
    Security_Q9_qldb_export_export_encryption_check,
  [`protect-data-transit_appmesh_virt_node_listener_strict_tls_check`]:
    Security_Q9_appmesh_virt_node_listener_strict_tls_check,
  [`protect-data-transit_emr_security_config_encryption_in_transit_check`]:
    Security_Q9_emr_security_config_encryption_in_transit_check,
  [`protect-data-transit_kinesis_firehose_delivery_stream_encryption_enabled`]:
    Security_Q9_kinesis_firehose_delivery_stream_encryption_enabled,
  [`protect-data-transit_tls_policy_check`]: Security_Q9_tls_policy_check,
  [`protect-data-transit_is_connection_pwd_encrypt_configure`]:
    Security_Q9_is_connection_pwd_encrypt_configure,
  [`protect-data-transit_inter_cluster_encryption_in_transit_check`]:
    Security_Q9_inter_cluster_encryption_in_transit_check,
  [`protect-data-transit_cloudfront_cdn_encryption_check`]:
    Security_Q9_cloudfront_cdn_encryption_check,
  [`protect-data-transit_codebuild_insecure_ssl_check`]:
    Security_Q9_codebuild_insecure_ssl_check,
  [`protect-data-transit_elasticache_redis_in_transit_encryption_check`]:
    Security_Q9_elasticache_redis_in_transit_encryption_check,
  [`protect-data-transit_https_enforcement_check`]:
    Security_Q9_https_enforcement_check,
  [`protect-data-transit_client_authentication_check`]:
    Security_Q9_client_authentication_check,
  [`protect-data-transit_guard_duty_s3_protection_check`]:
    Security_Q9_guard_duty_s3_protection_check,
  [`protect-data-transit_s3_bucket_secure_request_check`]:
    Security_Q9_s3_bucket_secure_request_check,
  [`protect-data-transit_emr_clusters_security_configuration_attached_check`]:
    Security_Q9_emr_clusters_security_configuration_attached_check,
  [`network-protection_shield_advanced_elb_protection_check`]:
    Security_Q5_shield_advanced_elb_protection_check,
  [`network-protection_is_the_stage_protected_by_a_waf_wacl`]:
    Security_Q5_is_the_stage_protected_by_a_waf_wacl,
  [`network-protection_shield_advanced_drt_s3_bucket_check`]:
    Security_Q5_shield_advanced_drt_s3_bucket_check,
  [`network-protection_appmesh_mesh_egress_check`]:
    Security_Q5_appmesh_mesh_egress_check,
  [`network-protection_security_group_open_elasticsearch_check`]:
    Security_Q5_security_group_open_elasticsearch_check,
  [`network-protection_elbv2_drop_invalid_header_check`]:
    Security_Q5_elbv2_drop_invalid_header_check,
  [`network-protection_ec2_with_elastic_public_ip_check`]:
    Security_Q5_ec2_with_elastic_public_ip_check,
  [`network-protection_security_group_open_smb_check`]:
    Security_Q5_security_group_open_smb_check,
  [`network-protection_emr_public_sg_block_config_in_region`]:
    Security_Q5_emr_public_sg_block_config_in_region,
  [`network-protection_security_group_open_dcom_rpc_check`]:
    Security_Q5_security_group_open_dcom_rpc_check,
  [`network-protection_is_the_endpoint_healthy`]:
    Security_Q5_is_the_endpoint_healthy,
  [`network-protection_security_group_open_mysql_mariadb_check`]:
    Security_Q5_security_group_open_mysql_mariadb_check,
  [`network-protection_security_group_open_documentdb_check`]:
    Security_Q5_security_group_open_documentdb_check,
  [`network-protection_dms_replication_instance_public_access_check`]:
    Security_Q5_dms_replication_instance_public_access_check,
  [`network-protection_redshift_cluster_enhanced_vpc_routing_check`]:
    Security_Q5_redshift_cluster_enhanced_vpc_routing_check,
  [`network-protection_flow_logs_enabled_check`]:
    Security_Q5_flow_logs_enabled_check,
  [`network-protection_shield_advanced_elb_v2_protection_check`]:
    Security_Q5_shield_advanced_elb_v2_protection_check,
  [`network-protection_security_group_open_memcached_check`]:
    Security_Q5_security_group_open_memcached_check,
  [`network-protection_security_group_open_cassandra_check`]:
    Security_Q5_security_group_open_cassandra_check,
  [`network-protection_security_group_open_redis_check`]:
    Security_Q5_security_group_open_redis_check,
  [`network-protection_shield_advanced_subscription_autorenew_check`]:
    Security_Q5_shield_advanced_subscription_autorenew_check,
  [`network-protection_workspaces_directory_default_internet_check`]:
    Security_Q5_workspaces_directory_default_internet_check,
  [`network-protection_security_group_open_oracle_check`]:
    Security_Q5_security_group_open_oracle_check,
  [`network-protection_guard_duty_enable_check`]:
    Security_Q5_guard_duty_enable_check,
  [`network-protection_shield_advanced_cloudfront_protection_check`]:
    Security_Q5_shield_advanced_cloudfront_protection_check,
  [`network-protection_shield_advanced_eip_protection_check`]:
    Security_Q5_shield_advanced_eip_protection_check,
  [`network-protection_lambda_function_vpc_check`]:
    Security_Q5_lambda_function_vpc_check,
  [`network-protection_broker_public_access_check`]:
    Security_Q5_broker_public_access_check,
  [`network-protection_security_group_open_telnet_check`]:
    Security_Q5_security_group_open_telnet_check,
  [`network-protection_elb_deletion_protection_check`]:
    Security_Q5_elb_deletion_protection_check,
  [`network-protection_security_group_open_elasticsearch2_check`]:
    Security_Q5_security_group_open_elasticsearch2_check,
  [`network-protection_security_group_open_splunkd_check`]:
    Security_Q5_security_group_open_splunkd_check,
  [`network-protection_shield_advanced_route_53_protection_check`]:
    Security_Q5_shield_advanced_route_53_protection_check,
  [`network-protection_security_group_open_redshift_check`]:
    Security_Q5_security_group_open_redshift_check,
  [`network-protection_security_group_open_postgresql_check`]:
    Security_Q5_security_group_open_postgresql_check,
  [`network-protection_vpc_default_check`]: Security_Q5_vpc_default_check,
  [`network-protection_security_group_open_kafka_check`]:
    Security_Q5_security_group_open_kafka_check,
  [`network-protection_security_group_open_mssql_check`]:
    Security_Q5_security_group_open_mssql_check,
  [`network-protection_eks_api_server_publicly_accessible_check`]:
    Security_Q5_eks_api_server_publicly_accessible_check,
  [`network-protection_security_group_open_kibana_check`]:
    Security_Q5_security_group_open_kibana_check,
};
